// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28180,185,200,0.7%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketing-report-page {
    padding-bottom: 48px;
}

.marketing-report-hero {
    margin: 0 0 20px;
}

.marketing-report-hero h1 {
    margin: 0 0 8px;
    font-size: 1.35rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
}

.marketing-report-hero p,
.marketing-report-hero__lede {
    margin: 0;
    max-width: 52rem;
    font-size: 0.875rem;
    line-height: 1.55;
    color: rgba(200, 200, 205, 0.9);
}

.marketing-report-section {
    margin-bottom: 28px;
}

.marketing-report-section__title {
    margin: 0 0 6px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.92);
}

.marketing-report-section__hint {
    margin: 0 0 14px;
    max-width: 44rem;
    font-size: 0.78rem;
    line-height: 1.45;
    color: rgba(165, 165, 175, 0.9);
}

.marketing-highlights {
    margin-bottom: 28px;
    padding: 18px 18px 20px;
    border-radius: 14px;
    border: 1px solid rgba(192, 159, 83, 0.24);
    background: linear-gradient(155deg, rgba(192, 159, 83, 0.1) 0%, rgba(0, 0, 0, 0.2) 55%);
}

.marketing-highlights__h2 {
    margin-bottom: 10px;
}

.marketing-highlights__eyebrow {
    margin: 0 0 6px;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.88);
}

.marketing-highlights__headline {
    margin: 0 0 8px;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1.35;
    color: rgba(245, 243, 238, 0.98);
}

.marketing-highlights__sub {
    margin: 0 0 16px;
    max-width: 44rem;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: rgba(185, 185, 192, 0.92);
}

.marketing-highlights__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 10px;
}

.marketing-highlights__item {
    margin: 0;
    padding: 12px 14px 12px 16px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-left-width: 3px;
}

.marketing-highlights__item--spotlight {
    border-left-color: rgba(192, 159, 83, 0.95);
}

.marketing-highlights__item--win {
    border-left-color: rgba(110, 185, 130, 0.9);
}

.marketing-highlights__item--watch {
    border-left-color: rgba(220, 145, 115, 0.9);
}

.marketing-highlights__item--data {
    border-left-color: rgba(140, 155, 190, 0.75);
}

.marketing-highlights__item-title {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(210, 205, 195, 0.95);
    margin-bottom: 6px;
}

.marketing-highlights__item-body {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: rgba(225, 225, 228, 0.94);
}

.marketing-report-banner {
    margin-bottom: 20px;
    padding: 12px 16px;
    border-radius: 10px;
    border: 1px solid rgba(192, 159, 83, 0.28);
    background: rgba(192, 159, 83, 0.08);
    font-size: 0.8125rem;
    line-height: 1.45;
    color: rgba(230, 225, 210, 0.95);
}

.marketing-report-summary {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 12px;
    margin-bottom: 22px;
}

.marketing-report-kpi {
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.22);
}

.marketing-report-kpi__label {
    display: block;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.9);
    margin-bottom: 6px;
}

.marketing-report-kpi__hint {
    margin: 6px 0 0;
    font-size: 0.7rem;
    line-height: 1.4;
    color: rgba(155, 155, 165, 0.95);
    font-weight: 400;
}

.marketing-report-kpi__value {
    font-size: 1.15rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: #f4f4f4;
}

.marketing-report-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.marketing-report-toolbar__left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.marketing-report-toolbar__placeholder {
    flex: 0 0 auto;
    min-width: 1px;
}

.marketing-report-back {
    flex: 0 0 auto;
    margin: 0;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.1);
    color: rgba(230, 220, 195, 0.98);
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
}

.marketing-report-back:hover {
    background: rgba(192, 159, 83, 0.18);
    border-color: rgba(192, 159, 83, 0.5);
}

.marketing-report-toolbar__meta {
    margin-left: auto;
    font-size: 0.78rem;
    color: rgba(180, 180, 188, 0.9);
    text-align: right;
}

.marketing-report-export {
    margin: 0;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.06);
    color: rgba(230, 230, 232, 0.96);
    font-size: 0.78rem;
    font-weight: 500;
    cursor: pointer;
}

.marketing-report-export:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.22);
}

.marketing-report-export--secondary {
    border-color: rgba(192, 159, 83, 0.22);
    background: rgba(192, 159, 83, 0.06);
    color: rgba(230, 220, 200, 0.95);
}

.marketing-report-export--secondary:hover {
    background: rgba(192, 159, 83, 0.12);
    border-color: rgba(192, 159, 83, 0.35);
}

.marketing-report-drill-title {
    margin: 0 0 12px;
    font-size: 1.05rem;
    font-weight: 600;
    color: rgba(235, 232, 225, 0.98);
}

.marketing-report-table-wrap {
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.18);
}

.marketing-report-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8125rem;
}

.marketing-report-table th,
.marketing-report-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.marketing-report-table th {
    font-weight: 600;
    color: rgba(192, 159, 83, 0.92);
    white-space: nowrap;
    background: rgba(0, 0, 0, 0.25);
}

.marketing-report-table td {
    color: rgba(230, 230, 232, 0.95);
    font-variant-numeric: tabular-nums;
}

.marketing-report-table tbody tr:last-child td {
    border-bottom: none;
}

.marketing-report-table tbody tr:hover td {
    background: rgba(255, 255, 255, 0.03);
}

.marketing-report-table__row--clickable {
    cursor: pointer;
}

.marketing-report-table__row--clickable:hover td {
    background: rgba(192, 159, 83, 0.07);
}

.marketing-report-table__row--clickable:focus {
    outline: none;
}

.marketing-report-table__row--clickable:focus-visible td:first-child {
    box-shadow: inset 3px 0 0 0 rgba(192, 159, 83, 0.85);
}

.marketing-report-channel-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.marketing-report-channel-cell__label {
    flex: 1;
    min-width: 0;
}

.marketing-report-channel-cell__chevron {
    flex-shrink: 0;
    font-size: 0.9rem;
    color: rgba(192, 159, 83, 0.75);
}

.marketing-report-table__empty-row {
    text-align: center;
    font-variant-numeric: normal;
    color: rgba(180, 180, 188, 0.88);
}

.marketing-report-table--with-choices {
    font-size: 0.78rem;
}

.marketing-report-table__col-choice {
    min-width: 6.75rem;
    max-width: 9.5rem;
    white-space: normal;
    text-align: right !important;
    font-variant-numeric: tabular-nums;
    line-height: 1.35;
}

.marketing-report-table th.marketing-report-table__col-choice {
    text-align: right;
    white-space: normal;
    line-height: 1.25;
}

.marketing-report-footnote {
    margin: 10px 0 0;
    max-width: 52rem;
    font-size: 0.75rem;
    line-height: 1.45;
    color: rgba(165, 165, 175, 0.92);
}

.marketing-report-table__col-channel {
    min-width: 10.5rem;
    max-width: 14rem;
    white-space: normal;
}

.marketing-report-table__col-campaign {
    min-width: 12rem;
    max-width: 28rem;
    white-space: normal;
    word-break: break-word;
    font-variant-numeric: normal;
}

.marketing-report-table__col-num {
    width: 1%;
    white-space: nowrap;
    text-align: right;
}

.marketing-report-table th.marketing-report-table__col-num {
    text-align: right;
}

.marketing-report-th-inner {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    justify-content: flex-start;
}

.marketing-report-table th.marketing-report-table__col-num .marketing-report-th-inner,
.marketing-report-table th.marketing-report-table__col-choice .marketing-report-th-inner {
    justify-content: flex-end;
}

.marketing-report-th-label {
    min-width: 0;
}

.marketing-report-col-sort {
    flex-shrink: 0;
    margin: 0;
    padding: 2px 6px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.2);
    color: rgba(175, 175, 185, 0.95);
    font-size: 0.65rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.02em;
    line-height: 1.2;
    cursor: pointer;
}

.marketing-report-col-sort:hover {
    border-color: rgba(192, 159, 83, 0.45);
    color: rgba(235, 228, 210, 0.98);
    background: rgba(192, 159, 83, 0.1);
}

.marketing-report-col-sort--active {
    border-color: rgba(192, 159, 83, 0.55);
    color: rgba(240, 232, 210, 0.98);
    background: rgba(192, 159, 83, 0.14);
}

.marketing-report-empty {
    padding: 28px 16px;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.5;
    color: rgba(180, 180, 188, 0.88);
}

.marketing-report-error {
    padding: 16px;
    border-radius: 10px;
    border: 1px solid rgba(255, 120, 120, 0.35);
    background: rgba(80, 20, 20, 0.25);
    color: rgba(255, 200, 200, 0.95);
    font-size: 0.875rem;
    margin-bottom: 16px;
}

.marketing-report-code {
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.35);
    font-size: 0.72rem;
    overflow-x: auto;
    color: rgba(220, 220, 225, 0.9);
}

.marketing-context {
    margin-bottom: 18px;
    padding: 14px 16px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
}

.marketing-context--empty {
    border-style: dashed;
    border-color: rgba(255, 255, 255, 0.1);
}

.marketing-context__title {
    margin: 0 0 6px;
    font-size: 0.95rem;
    font-weight: 600;
    color: rgba(235, 232, 225, 0.98);
}

.marketing-context__lede {
    margin: 0 0 14px;
    max-width: 48rem;
    font-size: 0.75rem;
    line-height: 1.45;
    color: rgba(175, 175, 185, 0.92);
}

.marketing-context__empty-note {
    margin: 0;
    max-width: 48rem;
    font-size: 0.78rem;
    line-height: 1.45;
    color: rgba(175, 175, 185, 0.9);
}

.marketing-context__empty-note code {
    font-size: 0.72rem;
    color: rgba(210, 195, 160, 0.95);
}

.marketing-context__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 16px;
    align-items: start;
}

.marketing-context__block-title {
    margin: 0 0 8px;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.88);
}

.marketing-context__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.72rem;
}

.marketing-context__table th,
.marketing-context__table td {
    padding: 6px 8px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    vertical-align: top;
}

.marketing-context__table th {
    font-weight: 600;
    color: rgba(192, 159, 83, 0.85);
    background: rgba(0, 0, 0, 0.2);
}

.marketing-context__label {
    word-break: break-word;
    font-variant-numeric: normal;
    color: rgba(230, 230, 232, 0.95);
}

.marketing-context__num {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.marketing-context__split {
    font-size: 0.68rem;
    line-height: 1.35;
    color: rgba(195, 195, 200, 0.9);
    font-variant-numeric: tabular-nums;
}

.marketing-report-compare-banner {
    margin: 12px 0 0;
    max-width: 52rem;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: rgba(210, 200, 175, 0.95);
}

.marketing-report-compare-warning {
    margin: 10px 0 0;
    max-width: 52rem;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid rgba(220, 150, 100, 0.35);
    background: rgba(60, 30, 15, 0.35);
    font-size: 0.8125rem;
    line-height: 1.45;
    color: rgba(255, 210, 185, 0.96);
}

.marketing-report-kpi__compare {
    display: block;
    margin-top: 6px;
    font-size: 0.72rem;
    font-weight: 500;
    line-height: 1.35;
}

.marketing-report-cell-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;
}

.marketing-report-table__col-campaign .marketing-report-cell-stack {
    align-items: flex-start;
}

.marketing-report-cell-stack__primary {
    font-variant-numeric: tabular-nums;
}

.marketing-report-cell-stack__compare {
    font-size: 0.68rem;
    line-height: 1.25;
    font-variant-numeric: tabular-nums;
}

.marketing-report-delta {
    font-weight: 600;
    letter-spacing: 0.01em;
}

.marketing-report-delta--up {
    color: rgba(130, 205, 155, 0.95);
}

.marketing-report-delta--down {
    color: rgba(235, 145, 125, 0.95);
}

.marketing-report-delta--flat {
    color: rgba(175, 175, 185, 0.9);
}

.marketing-report-delta--new {
    font-weight: 500;
    color: rgba(160, 185, 220, 0.92);
}

/*
 * Marketing dashboard chart strip.
 *
 * The overview view shows two cards side-by-side (choice mix donut +
 * channels bar). The channel drill-down shows five cards: a wide one for
 * "top campaigns" and four half-width for mix, acceptance %, countries,
 * and paths. On narrow screens everything collapses to a single column.
 */
.marketing-charts {
    margin-bottom: 28px;
}

.marketing-charts__grid {
    display: grid;
    gap: 16px;
}

.marketing-charts__grid--two-up {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.marketing-charts__grid--three-up {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1200px) {
    .marketing-charts__grid--three-up {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 820px) {
    .marketing-charts__grid--two-up,
    .marketing-charts__grid--three-up {
        grid-template-columns: 1fr;
    }
}

.marketing-charts__card {
    display: flex;
    flex-direction: column;
    min-height: 280px;
    padding: 14px 16px 16px;
    border-radius: 14px;
    border: 1px solid rgba(192, 159, 83, 0.18);
    background: linear-gradient(155deg, rgba(192, 159, 83, 0.06) 0%, rgba(0, 0, 0, 0.22) 60%);
}

.marketing-charts__card--wide {
    grid-column: span 2;
}

@media (max-width: 1200px) {
    .marketing-charts__card--wide {
        grid-column: span 2;
    }
}

@media (max-width: 820px) {
    .marketing-charts__card--wide {
        grid-column: span 1;
    }
}

.marketing-charts__card-header {
    margin-bottom: 8px;
}

.marketing-charts__card-title {
    margin: 0 0 4px;
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(245, 243, 238, 0.96);
}

.marketing-charts__card-sub {
    margin: 0;
    font-size: 0.74rem;
    line-height: 1.4;
    color: rgba(170, 170, 180, 0.9);
}

.marketing-charts__card-body {
    flex: 1;
    min-height: 220px;
    position: relative;
}

/*
 * AnyChart's pie/bar containers need an explicit height; the inner chart
 * renders into a block element inside <div class="chart">.
 */
.marketing-charts__card-body .widget {
    height: 100%;
    min-height: 220px;
}

.marketing-charts__card-body .chart {
    width: 100%;
    min-height: 220px;
}

.marketing-charts__empty {
    margin: 0;
    padding: 18px 14px;
    font-size: 0.82rem;
    line-height: 1.5;
    color: rgba(170, 170, 180, 0.88);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px dashed rgba(192, 159, 83, 0.24);
}

.marketing-charts__card--timeseries {
    margin-top: 0;
}

.marketing-charts__card-body--tall {
    min-height: 350px;
}

.marketing-charts__card-body--tall .widget,
.marketing-charts__card-body--tall .chart {
    min-height: 350px;
}

/*
 * --- Visibility reframe --------------------------------------------------
 *
 * The "analytics-invisible traffic" narrative and supporting cues.
 * Color palette stays in the platform gold/amber family so the warning
 * reads as "pay attention" rather than "something is broken" — this is a
 * product-level insight, not an error state.
 */

.marketing-report-visibility-narrative {
    margin: 4px 0 16px;
    padding: 12px 14px 13px;
    max-width: 62rem;
    font-size: 0.85rem;
    line-height: 1.55;
    color: rgba(240, 230, 205, 0.95);
    background: linear-gradient(155deg, rgba(210, 165, 80, 0.12) 0%, rgba(0, 0, 0, 0.25) 65%);
    border: 1px solid rgba(210, 165, 80, 0.28);
    border-left: 3px solid rgba(210, 165, 80, 0.82);
    border-radius: 10px;
}

.marketing-report-visibility-narrative strong {
    color: rgba(255, 235, 195, 1);
    font-weight: 600;
}

.marketing-report-kpi--warn {
    border-color: rgba(210, 165, 80, 0.45);
    background: linear-gradient(155deg, rgba(210, 165, 80, 0.12) 0%, rgba(0, 0, 0, 0.24) 60%);
}

.marketing-report-kpi--warn .marketing-report-kpi__label {
    color: rgba(235, 205, 145, 0.92);
}

.marketing-report-kpi--warn .marketing-report-kpi__value {
    color: rgba(255, 235, 195, 1);
}

/*
 * Per-row "analytics blind spot" highlight.
 *
 * A faint amber tint + a thick leading border drawn via a box-shadow
 * inset so it doesn't shift row layout. The badge sits next to the
 * campaign / channel name in lowercase to read as a label, not a button.
 */

.marketing-report-table__row--blind-spot {
    background: rgba(210, 165, 80, 0.06);
    box-shadow: inset 3px 0 0 0 rgba(210, 165, 80, 0.6);
}

.marketing-report-table__row--blind-spot.marketing-report-table__row--clickable:hover,
.marketing-report-table__row--blind-spot:hover {
    background: rgba(210, 165, 80, 0.12);
}

.marketing-report-blind-spot-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: lowercase;
    color: rgba(255, 225, 170, 0.98);
    background: rgba(210, 165, 80, 0.18);
    border: 1px solid rgba(210, 165, 80, 0.45);
    border-radius: 999px;
    vertical-align: middle;
    white-space: nowrap;
}

/*
 * --- Channels table pagination -----------------------------------------
 *
 * Compact pager shown under the overview table so the list never grows
 * past ten rows. Prev/Next buttons sit to either side of the numbered
 * pages; ellipsis gaps compress long page lists. Meta text reports the
 * window so totals stay visible without the user opening the CSV export.
 */

.marketing-report-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px 10px;
    margin-top: 14px;
    padding: 18px 8px 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.marketing-report-pagination__btn {
    padding: 7px 12px;
    font-size: 0.8rem;
    font-family: inherit;
    color: rgba(225, 225, 230, 0.94);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 7px;
    cursor: pointer;
    transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
}

.marketing-report-pagination__btn:hover:not(:disabled) {
    border-color: rgba(210, 165, 80, 0.55);
    color: rgba(255, 225, 170, 0.98);
    background: rgba(210, 165, 80, 0.08);
}

.marketing-report-pagination__btn:focus-visible {
    outline: 2px solid rgba(210, 165, 80, 0.7);
    outline-offset: 2px;
}

.marketing-report-pagination__btn:disabled {
    opacity: 0.38;
    cursor: not-allowed;
}

.marketing-report-pagination__pages {
    display: flex;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.marketing-report-pagination__page {
    min-width: 34px;
    padding: 7px 10px;
    font-size: 0.8rem;
    font-family: inherit;
    color: rgba(225, 225, 230, 0.88);
    background: transparent;
    border: 1px solid transparent;
    border-radius: 7px;
    cursor: pointer;
    transition: background 120ms ease, border-color 120ms ease, color 120ms ease;
}

.marketing-report-pagination__page:hover {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 225, 170, 0.98);
}

.marketing-report-pagination__page:focus-visible {
    outline: 2px solid rgba(210, 165, 80, 0.7);
    outline-offset: 2px;
}

.marketing-report-pagination__page--active,
.marketing-report-pagination__page--active:hover {
    color: rgba(20, 18, 12, 0.96);
    background: linear-gradient(155deg, rgba(216, 181, 106, 0.96) 0%, rgba(184, 141, 60, 0.96) 100%);
    border-color: rgba(192, 159, 83, 0.65);
    font-weight: 600;
    cursor: default;
}

.marketing-report-pagination__gap {
    padding: 7px 2px;
    color: rgba(160, 160, 170, 0.7);
    -webkit-user-select: none;
    user-select: none;
}

.marketing-report-pagination__meta {
    flex-basis: 100%;
    margin-top: 2px;
    font-size: 0.76rem;
    line-height: 1.4;
    color: rgba(180, 180, 190, 0.86);
    text-align: center;
}

.marketing-report-pagination__meta strong {
    color: rgba(230, 230, 235, 0.95);
    font-weight: 600;
}

@media (min-width: 720px) {
    .marketing-report-pagination__meta {
        flex-basis: auto;
        margin-top: 0;
        margin-left: 12px;
        text-align: left;
    }
}

/*
 * --- Ad-platform reconciliation panel ----------------------------------
 *
 * Sits between the KPI grid and the chart strip. Inputs stack responsively;
 * result cards flow in a 3–4 column grid on wide screens, collapsing to a
 * single column on phones. The "good" and "warn" tones match the rest of
 * the dashboard's palette (green accents for visibility, gold/amber for the
 * invisible-gap card).
 */

.marketing-reconciliation {
    margin: 0 0 28px;
    padding: 18px 18px 20px;
    border-radius: 14px;
    border: 1px solid rgba(192, 159, 83, 0.24);
    background: linear-gradient(
        155deg,
        rgba(192, 159, 83, 0.08) 0%,
        rgba(0, 0, 0, 0.22) 65%
    );
}

.marketing-reconciliation__header {
    margin-bottom: 14px;
}

.marketing-reconciliation__inputs {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr auto;
    gap: 12px 14px;
    align-items: end;
    margin-bottom: 8px;
}

@media (max-width: 900px) {
    .marketing-reconciliation__inputs {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 540px) {
    .marketing-reconciliation__inputs {
        grid-template-columns: 1fr;
    }
}

.marketing-reconciliation__field {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
}

.marketing-reconciliation__field-label {
    font-size: 0.74rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: rgba(195, 195, 205, 0.86);
}

.marketing-reconciliation__input,
.marketing-reconciliation__select {
    width: 100%;
    height: 38px;
    padding: 0 11px;
    box-sizing: border-box;
    font-size: 0.88rem;
    font-family: inherit;
    color: rgba(245, 243, 238, 0.98);
    background: rgba(0, 0, 0, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 8px;
    outline: none;
    transition:
        border-color 120ms ease,
        background 120ms ease;
}

.marketing-reconciliation__select {
    -webkit-appearance: none;
    appearance: none;
    padding-right: 28px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 9px center;
    cursor: pointer;
}

.marketing-reconciliation__input:focus,
.marketing-reconciliation__select:focus {
    border-color: rgba(192, 159, 83, 0.6);
    background: rgba(0, 0, 0, 0.38);
}

.marketing-reconciliation__money {
    display: flex;
    gap: 6px;
    min-width: 0;
}

.marketing-reconciliation__input--money {
    flex: 1;
    min-width: 0;
}

.marketing-reconciliation__select--currency {
    flex: 0 0 auto;
    width: 88px;
}

.marketing-reconciliation__actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
}

.marketing-reconciliation__clear {
    padding: 9px 14px;
    font-size: 0.82rem;
    font-family: inherit;
    color: rgba(215, 215, 220, 0.94);
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    cursor: pointer;
    transition:
        border-color 120ms ease,
        color 120ms ease;
}

.marketing-reconciliation__clear:hover {
    border-color: rgba(210, 165, 80, 0.5);
    color: rgba(255, 225, 170, 0.98);
}

.marketing-reconciliation__window-hint {
    margin: 2px 0 16px;
    font-size: 0.76rem;
    line-height: 1.5;
    color: rgba(160, 160, 170, 0.88);
}

.marketing-reconciliation__empty {
    padding: 18px 16px;
    font-size: 0.88rem;
    line-height: 1.55;
    color: rgba(185, 185, 195, 0.92);
    border: 1px dashed rgba(192, 159, 83, 0.28);
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.12);
}

.marketing-reconciliation__empty strong {
    color: rgba(245, 243, 238, 0.98);
    font-weight: 600;
}

/*
 * Result grid: 4-up on wide desktops (three reconciliation cards + cost
 * card when spend is entered), graceful fallback to 2-up and 1-up.
 */
.marketing-reconciliation__results {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
    margin-top: 4px;
}

.marketing-reconciliation__result {
    padding: 14px 14px 15px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.035);
}

.marketing-reconciliation__result--good {
    border-color: rgba(140, 200, 130, 0.35);
    background: linear-gradient(
        155deg,
        rgba(140, 200, 130, 0.12) 0%,
        rgba(0, 0, 0, 0.25) 60%
    );
}

.marketing-reconciliation__result--warn {
    border-color: rgba(210, 165, 80, 0.45);
    background: linear-gradient(
        155deg,
        rgba(210, 165, 80, 0.14) 0%,
        rgba(0, 0, 0, 0.25) 60%
    );
}

.marketing-reconciliation__result-title {
    margin: 0 0 6px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(195, 195, 205, 0.92);
}

.marketing-reconciliation__result--good .marketing-reconciliation__result-title {
    color: rgba(175, 220, 165, 0.95);
}

.marketing-reconciliation__result--warn .marketing-reconciliation__result-title {
    color: rgba(235, 200, 140, 0.95);
}

.marketing-reconciliation__result-headline {
    margin: 0 0 6px;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.25;
    color: rgba(245, 243, 238, 0.98);
}

.marketing-reconciliation__result-detail {
    margin: 0;
    font-size: 0.82rem;
    line-height: 1.5;
    color: rgba(195, 195, 205, 0.9);
}

.marketing-reconciliation__result-sub {
    margin: 8px 0 0;
    padding-top: 8px;
    font-size: 0.76rem;
    line-height: 1.5;
    color: rgba(170, 170, 180, 0.86);
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

/*
 * --- Reconciliation: save / snapshots --------------------------------
 *
 * The save button shares the actions slot with "Clear inputs" and gets
 * the gold accent treatment so it reads as the primary CTA. The
 * snapshots list is a collapsible details-style block with a compact
 * table — wide enough to be useful, narrow enough not to dominate.
 */

.marketing-reconciliation__actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
}

@media (min-width: 901px) {
    .marketing-reconciliation__actions {
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
    }
}

.marketing-reconciliation__save {
    padding: 9px 16px;
    font-size: 0.84rem;
    font-weight: 600;
    font-family: inherit;
    color: rgba(20, 18, 12, 0.96);
    background: linear-gradient(155deg, #d8b56a 0%, #b88d3c 100%);
    border: 1px solid rgba(192, 159, 83, 0.7);
    border-radius: 8px;
    cursor: pointer;
    transition:
        transform 80ms ease,
        box-shadow 120ms ease,
        opacity 120ms ease;
}

.marketing-reconciliation__save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px -8px rgba(210, 165, 80, 0.6);
}

.marketing-reconciliation__save:disabled {
    cursor: not-allowed;
    opacity: 0.45;
}

.marketing-reconciliation__snapshots {
    margin-top: 20px;
    padding: 18px 22px;
    background: rgba(255,255,255,0.028);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
}

.marketing-reconciliation__snapshots-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.marketing-reconciliation__snapshots-toggle {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px 7px 6px;
    margin-left: -6px;
    font-size: 0.86rem;
    font-weight: 600;
    font-family: inherit;
    color: rgba(235, 233, 228, 0.96);
    background: transparent;
    border: 1px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: background 120ms ease;
}

.marketing-reconciliation__snapshots-toggle:hover {
    background: rgba(255, 255, 255, 0.04);
}

.marketing-reconciliation__snapshots-count {
    display: inline-flex;
    min-width: 22px;
    height: 22px;
    padding: 0 7px;
    align-items: center;
    justify-content: center;
    font-size: 0.74rem;
    font-weight: 600;
    color: rgba(255, 225, 170, 0.98);
    background: rgba(210, 165, 80, 0.18);
    border: 1px solid rgba(210, 165, 80, 0.45);
    border-radius: 999px;
}

.marketing-reconciliation__snapshots-actions {
    display: inline-flex;
    gap: 8px;
}

.marketing-reconciliation__snapshots-export,
.marketing-reconciliation__snapshots-clear {
    padding: 7px 12px;
    font-size: 0.78rem;
    font-family: inherit;
    color: rgba(225, 225, 230, 0.94);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 7px;
    cursor: pointer;
    transition:
        border-color 120ms ease,
        color 120ms ease,
        background 120ms ease;
}

.marketing-reconciliation__snapshots-export:hover {
    border-color: rgba(210, 165, 80, 0.55);
    color: rgba(255, 225, 170, 0.98);
}

.marketing-reconciliation__snapshots-clear:hover {
    border-color: rgba(220, 110, 110, 0.55);
    color: rgba(245, 175, 175, 0.98);
}

.marketing-reconciliation__snapshots-empty {
    margin: 14px 0 0;
    padding: 14px 14px;
    font-size: 0.84rem;
    line-height: 1.55;
    color: rgba(180, 180, 190, 0.9);
    border: 1px dashed rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
}

.marketing-reconciliation__snapshots-empty strong {
    color: rgba(245, 243, 238, 0.98);
    font-weight: 600;
}

.marketing-reconciliation__snapshots-table-wrap {
    margin-top: 14px;
    overflow-x: auto;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
}

.marketing-reconciliation__snapshots-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
    color: rgba(225, 225, 230, 0.94);
}

.marketing-reconciliation__snapshots-table thead th {
    padding: 9px 10px;
    text-align: left;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(180, 180, 190, 0.92);
    background: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
}

.marketing-reconciliation__snapshots-table tbody td {
    padding: 9px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    vertical-align: top;
}

.marketing-reconciliation__snapshots-table tbody tr:last-child td {
    border-bottom: none;
}

.marketing-reconciliation__snapshots-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.025);
}

.marketing-reconciliation__snapshots-table .num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.marketing-reconciliation__snapshots-metric,
.marketing-reconciliation__snapshots-sub {
    color: rgba(160, 160, 170, 0.86);
    font-size: 0.74rem;
}

.marketing-reconciliation__snapshots-delete {
    padding: 2px 8px;
    font-size: 1rem;
    line-height: 1;
    font-family: inherit;
    color: rgba(200, 200, 210, 0.7);
    background: transparent;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    transition:
        color 120ms ease,
        border-color 120ms ease,
        background 120ms ease;
}

.marketing-reconciliation__snapshots-delete:hover {
    color: rgba(245, 175, 175, 0.98);
    border-color: rgba(220, 110, 110, 0.45);
    background: rgba(220, 110, 110, 0.08);
}

/*
 * --- Reconciliation: over-count & caption ----------------------------
 *
 * "Over-count" = the scope's attributed consents exceed the reported
 * clicks/sessions from the ad platform (multi-session visits, pre-
 * consented returns, UTM-tagged URLs shared beyond the ad). The row is
 * lightly tinted amber, the Reported cell carries a compact badge, and
 * the in-cell share label is capped at "100%+" so the math stays
 * readable.
 */
.marketing-reconciliation__snapshots-caption {
    margin: 0 0 10px;
    font-size: 0.78rem;
    line-height: 1.55;
    color: rgba(180, 180, 190, 0.86);
}

.marketing-reconciliation__over-count-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    padding: 1px 7px;
    font-size: 0.66rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: lowercase;
    color: rgba(255, 225, 170, 0.98);
    background: rgba(210, 165, 80, 0.18);
    border: 1px solid rgba(210, 165, 80, 0.45);
    border-radius: 999px;
    vertical-align: middle;
    white-space: nowrap;
}

.marketing-reconciliation__over-count-badge--inline {
    margin: 0 4px;
}

.marketing-reconciliation__snapshots-row--overcount {
    background: rgba(210, 165, 80, 0.05);
    box-shadow: inset 3px 0 0 0 rgba(210, 165, 80, 0.45);
}

.marketing-reconciliation__snapshots-row--overcount:hover {
    background: rgba(210, 165, 80, 0.09);
}

/*
 * --- Reconciliation: platform filter note ----------------------------
 *
 * The filter note sits between the inputs and the result cards. When
 * the filter is active and matched, it shows the coverage + matched
 * utm_source values. When active and empty, it swaps to a warn tone
 * prompting the user to fix their UTM tagging or switch to "Other".
 */

.marketing-reconciliation__filter-note {
    margin: 0 0 14px;
    padding: 10px 14px;
    font-size: 0.82rem;
    line-height: 1.55;
    color: rgba(215, 215, 220, 0.92);
    background: rgba(0, 0, 0, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
}

.marketing-reconciliation__filter-note p {
    margin: 0;
}

.marketing-reconciliation__filter-note code {
    padding: 1px 6px;
    font-size: 0.78rem;
    color: rgba(255, 225, 170, 0.95);
    background: rgba(210, 165, 80, 0.1);
    border: 1px solid rgba(210, 165, 80, 0.25);
    border-radius: 5px;
}

.marketing-reconciliation__filter-note--empty {
    color: rgba(245, 210, 170, 0.96);
    background: linear-gradient(
        155deg,
        rgba(210, 130, 80, 0.15) 0%,
        rgba(0, 0, 0, 0.22) 65%
    );
    border-color: rgba(220, 140, 90, 0.45);
}

/*
 * --- Reconciliation content tabs ----------------------------------------
 * Same pattern as .compliance-transfers__tab (Pages/Compliance/Style.css) —
 * no shared <Tabs> component exists in this app, so this mirrors that one
 * rather than inventing a new idiom.
 */

.recon-tabs {
    display: flex;
    gap: 2px;
    margin: 4px 0 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.recon-tab {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 8px 14px 10px;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    color: rgba(255, 255, 255, 0.35);
    font-size: 0.8rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    margin-bottom: -1px;
    transition: color 0.15s ease, border-color 0.15s ease;
}

.recon-tab:hover {
    color: rgba(255, 255, 255, 0.6);
}

.recon-tab.--active {
    color: rgba(255, 255, 255, 0.88);
    border-bottom-color: #c0a053;
}

/*
 * --- Reconciliation two-column layout -----------------------------------
 * Main content + a collapsible Suggestions rail. Sticky on wide screens so
 * suggestions stay visible while scrolling through tab content; stacks to
 * a single column on narrow screens.
 */

.recon-layout {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 20px;
    align-items: start;
}

.recon-layout__main {
    min-width: 0;
}

.recon-layout__sidebar {
    position: sticky;
    top: 16px;
}

@media (max-width: 960px) {
    .recon-layout {
        grid-template-columns: 1fr;
    }
    .recon-layout__sidebar {
        position: static;
    }
}

.recon-sidecard__toggle {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px 7px 6px;
    margin: 0 0 8px -6px;
    font-size: 0.86rem;
    font-weight: 600;
    font-family: inherit;
    color: rgba(235, 233, 228, 0.96);
    background: transparent;
    border: 1px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: background 120ms ease;
}

.recon-sidecard__toggle:hover {
    background: rgba(255, 255, 255, 0.04);
}

.recon-sidecard__count {
    display: inline-flex;
    min-width: 22px;
    height: 22px;
    padding: 0 7px;
    align-items: center;
    justify-content: center;
    font-size: 0.74rem;
    font-weight: 600;
    color: rgba(255, 225, 170, 0.98);
    background: rgba(210, 165, 80, 0.18);
    border: 1px solid rgba(210, 165, 80, 0.45);
    border-radius: 999px;
}

/*
 * --- Suggestions strip ------------------------------------------------
 *
 * Sits between the KPI grid and the reconciliation panel. Visually quieter
 * than the KPI cards (no large numbers) so it reads as a *next move*
 * footnote, not as another metric. Severity is encoded in (1) a chip in
 * the card head, (2) a coloured left border, and (3) a faint background
 * tint — three independent cues so colour-blind readers still see the
 * priority distinction.
 */

.marketing-suggestions {
    margin: 0 0 28px;
    padding: 16px 18px 18px;
    border-radius: 14px;
    background: linear-gradient(
        155deg,
        rgba(255, 255, 255, 0.03) 0%,
        rgba(255, 255, 255, 0.01) 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.marketing-suggestions__head {
    margin: 0 0 12px;
}

.marketing-suggestions__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: rgba(240, 232, 210, 0.95);
}

.marketing-suggestions__hint {
    margin: 4px 0 0;
    font-size: 0.78rem;
    line-height: 1.45;
    color: rgba(165, 165, 175, 0.9);
    max-width: 56rem;
}

.marketing-suggestions__list {
    display: grid;
    gap: 10px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.marketing-suggestions__card {
    position: relative;
    padding: 14px 16px 14px 18px;
    background: rgba(255, 255, 255, 0.025);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 10px;
    border-left-width: 3px;
}

.marketing-suggestions__card--critical {
    border-left-color: rgba(232, 95, 95, 0.85);
    background: linear-gradient(
        155deg,
        rgba(232, 95, 95, 0.08) 0%,
        rgba(255, 255, 255, 0.015) 70%
    );
}

.marketing-suggestions__card--high {
    border-left-color: rgba(210, 165, 80, 0.85);
    background: linear-gradient(
        155deg,
        rgba(210, 165, 80, 0.07) 0%,
        rgba(255, 255, 255, 0.015) 70%
    );
}

.marketing-suggestions__card--medium {
    border-left-color: rgba(130, 175, 220, 0.85);
    background: linear-gradient(
        155deg,
        rgba(130, 175, 220, 0.05) 0%,
        rgba(255, 255, 255, 0.015) 70%
    );
}

.marketing-suggestions__card--low {
    border-left-color: rgba(160, 160, 170, 0.6);
}

.marketing-suggestions__card-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
}

.marketing-suggestions__severity {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    font-size: 0.66rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border-radius: 999px;
    border: 1px solid currentColor;
    line-height: 1.4;
}

.marketing-suggestions__severity--critical {
    color: rgba(255, 180, 180, 0.95);
    background: rgba(232, 95, 95, 0.12);
}

.marketing-suggestions__severity--high {
    color: rgba(255, 225, 170, 0.95);
    background: rgba(210, 165, 80, 0.14);
}

.marketing-suggestions__severity--medium {
    color: rgba(190, 220, 245, 0.95);
    background: rgba(130, 175, 220, 0.12);
}

.marketing-suggestions__severity--low {
    color: rgba(200, 200, 210, 0.85);
    background: rgba(255, 255, 255, 0.04);
}

.marketing-suggestions__card-title {
    margin: 0;
    font-size: 0.92rem;
    font-weight: 600;
    color: rgba(240, 232, 210, 0.96);
    line-height: 1.35;
}

.marketing-suggestions__card-body {
    margin: 0 0 10px;
    font-size: 0.84rem;
    line-height: 1.5;
    color: rgba(200, 200, 210, 0.92);
}

.marketing-suggestions__card-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
}

.marketing-suggestions__cta {
    display: inline-flex;
    align-items: center;
    padding: 7px 14px;
    font-size: 0.82rem;
    font-weight: 600;
    color: rgba(20, 18, 12, 0.96);
    background: linear-gradient(
        155deg,
        rgba(216, 181, 106, 0.96) 0%,
        rgba(184, 141, 60, 0.96) 100%
    );
    border-radius: 7px;
    text-decoration: none;
    transition: filter 120ms ease, transform 120ms ease;
}

.marketing-suggestions__cta:hover,
.marketing-suggestions__cta:focus-visible {
    filter: brightness(1.07);
    text-decoration: none;
}

.marketing-suggestions__cta:focus-visible {
    outline: 2px solid rgba(255, 225, 170, 0.85);
    outline-offset: 2px;
}

.marketing-suggestions__snooze {
    padding: 6px 10px;
    font-size: 0.76rem;
    font-family: inherit;
    color: rgba(200, 200, 210, 0.86);
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 7px;
    cursor: pointer;
    transition: border-color 120ms ease, color 120ms ease, background 120ms ease;
}

.marketing-suggestions__snooze:hover,
.marketing-suggestions__snooze:focus-visible {
    border-color: rgba(255, 255, 255, 0.32);
    color: rgba(240, 240, 245, 0.96);
    background: rgba(255, 255, 255, 0.04);
}

.marketing-suggestions__snooze:focus-visible {
    outline: 2px solid rgba(160, 160, 170, 0.6);
    outline-offset: 2px;
}

.marketing-suggestions__evidence {
    margin-top: 10px;
    font-size: 0.76rem;
    color: rgba(160, 160, 170, 0.9);
}

.marketing-suggestions__evidence summary {
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    color: rgba(180, 180, 190, 0.86);
    transition: color 120ms ease;
}

.marketing-suggestions__evidence summary:hover {
    color: rgba(220, 220, 230, 0.96);
}

.marketing-suggestions__evidence ul {
    margin: 8px 0 0;
    padding: 0 0 0 18px;
    line-height: 1.55;
}

.marketing-suggestions__evidence code {
    padding: 1px 6px;
    font-size: 0.74rem;
    color: rgba(220, 220, 230, 0.92);
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
}

@media (min-width: 720px) {
    .marketing-suggestions__card-head {
        flex-wrap: nowrap;
    }
}

/* ── Ad Reconciliation CTA (in Channel Analytics) ─────────────────────── */
.marketing-reconciliation-cta {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px 24px;
    margin: 32px 0;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.marketing-reconciliation-cta__text {
    margin: 0;
    color: rgba(220, 220, 230, 0.75);
    font-size: 0.9rem;
}

.marketing-reconciliation-cta__link {
    white-space: nowrap;
    font-size: 0.88rem;
    font-weight: 600;
    color: #7c9ff5;
    text-decoration: none;
}

.marketing-reconciliation-cta__link:hover {
    text-decoration: underline;
}

/* ── Reconcile page channel filter ────────────────────────────────────── */
.marketing-reconciliation-page__channel-filter {
    margin-bottom: 24px;
}

.marketing-reconciliation-page__channel-label {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.88rem;
    color: rgba(220, 220, 230, 0.8);
}

.marketing-reconciliation-page__back-link {
    color: #7c9ff5;
    text-decoration: none;
}

.marketing-reconciliation-page__back-link:hover {
    text-decoration: underline;
}

/* ── Shared section headers ────────────────────────────────────────────── */
.marketing-reconciliation__section-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: rgba(220, 220, 230, 0.9);
    margin: 0 0 4px;
}

.marketing-reconciliation__section-hint {
    font-size: 0.82rem;
    color: rgba(200, 200, 210, 0.55);
    margin: 0 0 16px;
    line-height: 1.5;
}

/* ── Platform comparison table ─────────────────────────────────────────── */
.marketing-reconciliation__comparison {
    margin: 28px 0 0;
    padding: 20px 24px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
}

.marketing-reconciliation__comparison-wrap {
    overflow-x: auto;
}

.marketing-reconciliation__comparison-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.86rem;
}

.marketing-reconciliation__comparison-table th,
.marketing-reconciliation__comparison-table td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    white-space: nowrap;
}

.marketing-reconciliation__comparison-table th {
    font-size: 0.78rem;
    font-weight: 600;
    color: rgba(200, 200, 210, 0.55);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.marketing-reconciliation__comparison-table td {
    color: rgba(220, 220, 230, 0.85);
}

.marketing-reconciliation__comparison-table tr:last-child td {
    border-bottom: none;
}

.marketing-reconciliation__comparison-table .num {
    text-align: right;
}

.marketing-reconciliation__comparison-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
    vertical-align: middle;
    flex-shrink: 0;
}

.marketing-reconciliation__comparison-good {
    color: #4caf7d;
    font-weight: 600;
}

.marketing-reconciliation__comparison-warn {
    color: #f5a623;
    font-weight: 600;
}

/* ── Visibility improvement projection ─────────────────────────────────── */
.marketing-reconciliation__projection {
    margin: 20px 0 0;
    padding: 22px 24px;
    background: rgba(255, 255, 255, 0.028);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
}

.marketing-reconciliation__projection-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.86rem;
}

.marketing-reconciliation__projection-table th,
.marketing-reconciliation__projection-table td {
    padding: 8px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.marketing-reconciliation__projection-table th {
    font-size: 0.78rem;
    font-weight: 600;
    color: rgba(200, 200, 210, 0.55);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.marketing-reconciliation__projection-table td {
    color: rgba(220, 220, 230, 0.85);
}

.marketing-reconciliation__projection-table tr:last-child td {
    border-bottom: none;
}

.marketing-reconciliation__projection-table .num {
    text-align: right;
}

.marketing-reconciliation__projection-row--current td {
    color: rgba(200, 200, 210, 0.55);
    font-style: italic;
}

/* ── Visibility trend chart ────────────────────────────────────────────── */
.marketing-reconciliation__trend {
    margin: 20px 0 0;
    padding: 22px 24px;
    background: rgba(255, 255, 255, 0.028);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
}

.marketing-reconciliation__trend-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
    margin-bottom: 12px;
}

.marketing-reconciliation__trend-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.82rem;
    color: rgba(200, 200, 210, 0.8);
}

.marketing-reconciliation__trend-legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.marketing-reconciliation__trend-svg {
    display: block;
    width: 100%;
    height: auto;
    overflow: visible;
}

/* ── Domain gate ──────────────────────────────────────────────────────────── */

.reconcile-domain-gate {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 56px 24px;
    margin: 24px 0;
    border-radius: 16px;
    border: 1.5px dashed rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.04);
    text-align: center;
}

.reconcile-domain-gate__icon {
    font-size: 2rem;
    opacity: 0.55;
}

.reconcile-domain-gate__heading {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(240, 235, 220, 0.9);
}

.reconcile-domain-gate__body {
    margin: 0;
    max-width: 36rem;
    font-size: 0.875rem;
    line-height: 1.6;
    color: rgba(180, 175, 165, 0.85);
}

/* ── Ad Connection Manager ─────────────────────────────────────────────────── */

.ad-connection-manager {
    margin: 0 0 32px;
    padding: 20px 22px 22px;
    border-radius: 14px;
    border: 1px solid rgba(100, 180, 255, 0.15);
    background: rgba(30, 50, 80, 0.18);
}

.ad-connection-manager__header {
    margin-bottom: 14px;
}

.ad-connection-manager__title {
    margin: 0 0 6px;
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(130, 185, 255, 0.85);
}

.ad-connection-manager__hint {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.5;
    color: rgba(160, 165, 175, 0.85);
}

.ad-connection-manager__loading {
    font-size: 0.8rem;
    color: rgba(160, 165, 175, 0.7);
    margin: 0;
}

.ad-connection-manager__status {
    margin: 0 0 12px;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.8rem;
    background: rgba(60, 200, 100, 0.12);
    border: 1px solid rgba(60, 200, 100, 0.25);
    color: rgba(160, 230, 160, 0.95);
}

.ad-connection-manager__status--error {
    background: rgba(220, 80, 60, 0.1);
    border-color: rgba(220, 80, 60, 0.25);
    color: rgba(255, 160, 140, 0.95);
}

.ad-connection-manager__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* ── Individual connection card ────────────────────────────────────────────── */

.ad-connection-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.03);
    transition: border-color 0.15s;
}

.ad-connection-card--connected {
    border-color: rgba(60, 180, 255, 0.2);
    background: rgba(30, 80, 140, 0.12);
}

.ad-connection-card__icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.92);
}

.ad-connection-card__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.ad-connection-card__name {
    font-size: 0.84rem;
    font-weight: 500;
    color: rgba(220, 220, 228, 0.95);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ad-connection-card__meta {
    font-size: 0.75rem;
    color: rgba(120, 200, 120, 0.85);
}

.ad-connection-card__meta--dim {
    color: rgba(140, 140, 150, 0.65);
}

.ad-connection-card__actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.ad-connection-card__btn {
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 0.77rem;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.15s, opacity 0.15s;
}

.ad-connection-card__btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.ad-connection-card__btn--connect {
    background: rgba(60, 140, 255, 0.18);
    border-color: rgba(60, 140, 255, 0.35);
    color: rgba(130, 185, 255, 0.95);
}

.ad-connection-card__btn--connect:not(:disabled):hover {
    background: rgba(60, 140, 255, 0.28);
}

.ad-connection-card__btn--import {
    background: rgba(60, 200, 100, 0.14);
    border-color: rgba(60, 200, 100, 0.3);
    color: rgba(130, 220, 150, 0.95);
}

.ad-connection-card__btn--import:not(:disabled):hover {
    background: rgba(60, 200, 100, 0.24);
}

.ad-connection-card__btn--disconnect {
    background: transparent;
    border-color: rgba(200, 100, 80, 0.25);
    color: rgba(200, 140, 130, 0.75);
}

.ad-connection-card__btn--disconnect:hover {
    background: rgba(200, 80, 60, 0.1);
    color: rgba(220, 160, 145, 0.9);
}

/* ── Manual Customer ID input ──────────────────────────────── */
.ad-manual-input-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.ad-manual-input {
    background: #1a1d2e;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    padding: 28px 32px;
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.ad-manual-input__title {
    font-size: 1rem;
    font-weight: 600;
    color: rgba(220, 225, 235, 0.95);
    margin: 0;
}

.ad-manual-input__hint {
    font-size: 0.82rem;
    color: rgba(160, 165, 180, 0.8);
    margin: 0;
    line-height: 1.5;
}

.ad-manual-input__field {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 6px;
    padding: 10px 14px;
    color: rgba(220, 225, 235, 0.95);
    font-size: 0.9rem;
    width: 100%;
    outline: none;
    box-sizing: border-box;
}

.ad-manual-input__field:focus {
    border-color: rgba(100, 140, 255, 0.5);
}

.ad-manual-input__field::placeholder {
    color: rgba(160, 165, 180, 0.45);
}

.ad-manual-input__actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

/* ── Inputs bar ────────────────────────────────────────────── */
.recon-inputs-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 14px;
    padding-bottom: 14px;
    margin-bottom: 0;
}
.recon-inputs-bar__field {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.recon-inputs-bar__field--wide {
    flex: 1;
    min-width: 130px;
}
.recon-inputs-bar__label {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(160,165,175,0.85);
}
.recon-inputs-bar__actions {
    display: flex;
    gap: 8px;
    align-items: flex-end;
}

/* ── Funnel + Gauge layout ─────────────────────────────────── */
.recon-main {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    margin: 0;
    flex-wrap: wrap;
}

/* ── Funnel ────────────────────────────────────────────────── */
.recon-funnel {
    flex: 1;
    min-width: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    padding: 20px 16px 16px;
    border-radius: 14px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.025);
}
.recon-funnel__step {
    width: 100%;
    max-width: 200px;
    text-align: center;
    padding: 12px 16px;
    border-radius: 10px;
}
.recon-funnel__step--reported {
    background: rgba(120,160,220,0.1);
    border: 1px solid rgba(120,160,220,0.2);
}
.recon-funnel__step--consents {
    background: rgba(100,200,160,0.08);
    border: 1px solid rgba(100,200,160,0.2);
}
.recon-funnel__step--visible {
    background: rgba(80,200,120,0.12);
    border: 1px solid rgba(80,200,120,0.25);
}
.recon-funnel__num {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
    color: rgba(235,235,245,0.95);
}
.recon-funnel__label {
    font-size: 0.75rem;
    color: rgba(170,175,185,0.85);
}
.recon-funnel__arrow {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    padding: 6px 0;
}
.recon-funnel__arrow-pct {
    font-size: 0.7rem;
    color: rgba(150,155,165,0.8);
}
.recon-funnel__arrow-line {
    font-size: 1.1rem;
    color: rgba(150,155,165,0.5);
}
.recon-funnel__gap {
    margin-top: 12px;
    padding: 8px 14px;
    border-radius: 8px;
    background: rgba(220,80,60,0.08);
    border: 1px solid rgba(220,80,60,0.2);
    text-align: center;
    width: 100%;
    max-width: 200px;
}
.recon-funnel__gap-num {
    font-size: 1.1rem;
    font-weight: 700;
    color: rgba(240,140,120,0.9);
}
.recon-funnel__gap-label {
    font-size: 0.72rem;
    color: rgba(200,130,110,0.8);
}

/* ── Gauge ─────────────────────────────────────────────────── */
.recon-gauge {
    min-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 20px 16px;
    border-radius: 14px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.025);
}
.recon-gauge__svg {
    width: 180px;
    height: 160px;
    display: block;
}
.recon-gauge__cost {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.recon-gauge__cost-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(150,155,165,0.7);
}
.recon-gauge__cost-val {
    font-size: 1.2rem;
    font-weight: 700;
    color: rgba(235,235,245,0.95);
}
.recon-gauge__cost-sub {
    font-size: 0.72rem;
    color: rgba(150,155,165,0.7);
}

/* ── Connect hint ──────────────────────────────────────────── */
.reconcile-connect-hint {
    font-size: 0.78rem;
    color: rgba(140,160,190,0.8);
    margin-bottom: 16px;
}
.reconcile-connect-hint a {
    color: rgba(100,170,255,0.9);
    text-decoration: none;
}
.reconcile-connect-hint a:hover {
    text-decoration: underline;
}

/* ── Ad Connections success banner ─────────────────────────────────────── */
.ad-connections-success-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    margin-bottom: 20px;
    background: rgba(34, 197, 94, 0.12);
    border: 1px solid rgba(34, 197, 94, 0.35);
    border-radius: 8px;
    color: rgba(134, 239, 172, 0.95);
    font-size: 0.875rem;
    font-weight: 500;
}

/* ── Account Picker Modal ───────────────────────────────────────────────── */
.account-picker-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: rgba(8, 10, 18, 0.75);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.account-picker {
    background: #13161f;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    width: 100%;
    max-width: 480px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 60px rgba(0,0,0,0.6);
    outline: none;
}

.account-picker__header {
    padding: 24px 24px 0;
}

.account-picker__title {
    margin: 0 0 6px;
    font-size: 1.1rem;
    font-weight: 700;
    color: rgba(230,235,245,0.95);
}

.account-picker__sub {
    margin: 0;
    font-size: 0.85rem;
    color: rgba(160,170,190,0.8);
    line-height: 1.5;
}

.account-picker__body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 24px;
}

.account-picker__loading,
.account-picker__empty {
    color: rgba(160,170,190,0.7);
    font-size: 0.875rem;
    margin: 8px 0;
}

.account-picker__error {
    color: rgba(248,113,113,0.9);
    font-size: 0.875rem;
    margin: 8px 0;
}

.account-picker__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.account-picker__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.06);
    background: rgba(255,255,255,0.03);
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
}

.account-picker__item:hover {
    background: rgba(255,255,255,0.06);
    border-color: rgba(255,255,255,0.12);
}

.account-picker__item--selected {
    background: rgba(99,179,237,0.1);
    border-color: rgba(99,179,237,0.45);
}

.account-picker__item--dim {
    opacity: 0.55;
}

.account-picker__item-radio {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid rgba(160,170,190,0.4);
    background: transparent;
    position: relative;
    transition: border-color 0.15s;
}

.account-picker__item--selected .account-picker__item-radio {
    border-color: #63b3ed;
}

.account-picker__item--selected .account-picker__item-radio::after {
    content: "";
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: #63b3ed;
}

.account-picker__item-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.account-picker__item-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(220,230,245,0.95);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.account-picker__item-id {
    font-size: 0.75rem;
    color: rgba(140,155,180,0.75);
    font-family: monospace;
}

.account-picker__footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 24px 20px;
    border-top: 1px solid rgba(255,255,255,0.06);
}

.account-picker__btn {
    padding: 9px 20px;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: opacity 0.15s, background 0.15s;
}

.account-picker__btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.account-picker__btn--cancel {
    background: rgba(255,255,255,0.06);
    color: rgba(180,185,200,0.9);
}

.account-picker__btn--cancel:not(:disabled):hover {
    background: rgba(255,255,255,0.1);
}

.account-picker__btn--confirm {
    background: #3b82f6;
    color: #fff;
}

.account-picker__btn--confirm:not(:disabled):hover {
    background: #2563eb;
}

/* ── Sync button & messages ────────────────────────────────────────────── */
.recon-sync-btn {
    padding: 7px 14px;
    border-radius: 7px;
    background: rgba(59, 130, 246, 0.15);
    border: 1px solid rgba(59, 130, 246, 0.4);
    color: rgba(147, 197, 253, 0.95);
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s, border-color 0.15s;
    letter-spacing: 0.01em;
}
.recon-sync-btn:not(:disabled):hover {
    background: rgba(59, 130, 246, 0.28);
    border-color: rgba(59, 130, 246, 0.65);
}
.recon-sync-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.recon-sync-msg {
    font-size: 0.8rem;
    color: rgba(134, 239, 172, 0.9);
    margin: 6px 0 0;
    padding: 7px 12px;
    background: rgba(34,197,94,0.08);
    border: 1px solid rgba(34,197,94,0.25);
    border-radius: 6px;
}
.recon-sync-msg--error {
    color: rgba(252,165,165,0.9);
    background: rgba(239,68,68,0.08);
    border-color: rgba(239,68,68,0.25);
}
.recon-sync-msg__link {
    color: inherit;
    opacity: 0.8;
    text-decoration: underline;
}
.recon-sync-hint {
    font-size: 0.78rem;
    color: rgba(140,155,180,0.7);
    margin: 5px 0 0;
}
.recon-sync-hint a {
    color: rgba(100,170,255,0.85);
    text-decoration: none;
}
.recon-sync-hint a:hover { text-decoration: underline; }

/* ── UTM attribution health bar ────────────────────────────────────────── */
.utm-health {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 14px;
    margin: 8px 0;
    border-radius: 8px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    font-size: 0.8rem;
    flex-wrap: wrap;
}
.utm-health__label {
    color: rgba(160,170,190,0.8);
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 0.05em;
    white-space: nowrap;
    min-width: 110px;
}
.utm-health__track {
    flex: 1;
    min-width: 80px;
    height: 6px;
    border-radius: 3px;
    background: rgba(255,255,255,0.08);
    overflow: hidden;
}
.utm-health__fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.4s ease;
}
.utm-health--good .utm-health__fill { background: #4ade80; }
.utm-health--warn .utm-health__fill { background: #f59e0b; }
.utm-health--bad  .utm-health__fill { background: #f87171; }
.utm-health__stats {
    color: rgba(200,210,225,0.9);
    white-space: nowrap;
}
.utm-health__stats strong { font-weight: 700; }
.utm-health--good .utm-health__stats strong { color: #86efac; }
.utm-health--warn .utm-health__stats strong { color: #fcd34d; }
.utm-health--bad  .utm-health__stats strong { color: #fca5a5; }
.utm-health__dark {
    color: rgba(160,170,190,0.65);
    font-size: 0.75rem;
}

/* ── Insights panel ─────────────────────────────────────────────────────── */
.recon-insights {
    margin: 0;
    flex: 1;
}
.recon-insights__heading {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(160,170,190,0.7);
    margin: 0 0 10px;
}
.recon-insights__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.recon-insight {
    display: flex;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 10px;
    border-left: 3px solid transparent;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
}
.recon-insight--critical {
    background: rgba(239,68,68,0.07);
    border-color: rgba(239,68,68,0.25);
    border-left-color: #ef4444;
}
.recon-insight--warning {
    background: rgba(245,158,11,0.07);
    border-color: rgba(245,158,11,0.25);
    border-left-color: #f59e0b;
}
.recon-insight--opportunity {
    background: rgba(59,130,246,0.07);
    border-color: rgba(59,130,246,0.22);
    border-left-color: #3b82f6;
}
.recon-insight--good {
    background: rgba(34,197,94,0.06);
    border-color: rgba(34,197,94,0.2);
    border-left-color: #22c55e;
}
.recon-insight__icon {
    font-size: 1rem;
    flex-shrink: 0;
    margin-top: 1px;
    width: 18px;
    text-align: center;
}
.recon-insight--critical .recon-insight__icon { color: #f87171; }
.recon-insight--warning  .recon-insight__icon { color: #fbbf24; }
.recon-insight--opportunity .recon-insight__icon { color: #60a5fa; }
.recon-insight--good     .recon-insight__icon { color: #4ade80; }
.recon-insight__content {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}
.recon-insight__title {
    font-size: 0.875rem;
    font-weight: 700;
    color: rgba(220,230,245,0.95);
    margin: 0;
    line-height: 1.3;
}
.recon-insight__body {
    font-size: 0.8rem;
    color: rgba(170,180,200,0.85);
    margin: 0;
    line-height: 1.55;
}

/* ── Chart sections ─────────────────────────────────────────────────────── */
.recon-chart-section {
    margin: 0;
    background: rgba(255,255,255,0.028);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    padding: 20px 20px 16px;
}

.recon-chart-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.recon-bar-chart {
    display: block;
    width: 100%;
    max-width: 620px;
    height: auto;
    overflow: visible;
}

.recon-chart-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 10px;
    font-size: 0.78rem;
    color: rgba(160,175,200,0.75);
    align-items: center;
}

.recon-legend-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: middle;
    flex-shrink: 0;
}

/* ═══════════════════════════════════════════════════════════════════════════
   DASHBOARD LAYOUT — page header, KPI row, card grid
   ═══════════════════════════════════════════════════════════════════════════ */

.recon-page {
    padding-bottom: 48px;
}

/* ── Page header ──────────────────────────────────────────────────────────── */
.recon-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 24px;
    padding-bottom: 18px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
}
.recon-page-header__left {
    display: flex;
    align-items: baseline;
    gap: 12px;
    flex-wrap: wrap;
}
.recon-page-header__title {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 700;
    color: rgba(240,242,248,0.97);
    letter-spacing: -0.01em;
}
.recon-page-header__domain {
    font-size: 0.82rem;
    color: rgba(155,170,200,0.75);
    padding: 3px 10px;
    border-radius: 20px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
}
.recon-page-header__right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}
.recon-page-header__channel {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.8rem;
    color: rgba(160,165,175,0.8);
}

.recon-page-header__channel .marketing-reconciliation__select {
    width: auto;
    min-width: 140px;
}
.recon-page-header__back {
    font-size: 0.82rem;
    color: rgba(130,145,175,0.75);
    text-decoration: none;
    transition: color 0.15s;
}
.recon-page-header__back:hover {
    color: rgba(180,190,215,0.9);
}

/* ── Generic card ─────────────────────────────────────────────────────────── */
.recon-card {
    background: rgba(255,255,255,0.028);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    padding: 22px 22px 20px;
}
.recon-controls-card {
    margin-bottom: 20px;
}
.recon-card--insights {
    display: flex;
    flex-direction: column;
}
.recon-card__title {
    margin: 0 0 14px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(145,158,185,0.65);
}
.recon-card__empty-hint {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 24px 16px;
    font-size: 0.85rem;
    color: rgba(140,152,175,0.6);
    text-align: center;
}

/* ── KPI stat cards ───────────────────────────────────────────────────────── */
.recon-kpi-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 20px;
}
@media (max-width: 900px) {
    .recon-kpi-row { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
    .recon-kpi-row { grid-template-columns: 1fr 1fr; }
}

.recon-stat-card {
    background: rgba(255,255,255,0.032);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 12px;
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 3px;
}
.recon-stat-card--good {
    border-color: rgba(74,222,128,0.2);
    background: rgba(74,222,128,0.045);
}
.recon-stat-card--warn {
    border-color: rgba(245,158,11,0.2);
    background: rgba(245,158,11,0.045);
}
.recon-stat-card--bad {
    border-color: rgba(248,113,113,0.2);
    background: rgba(248,113,113,0.045);
}
.recon-stat-card--ga4 {
    border-color: rgba(227,116,0,0.25);
    background: rgba(227,116,0,0.055);
}
.recon-stat-card--ga4 .recon-stat-card__value { color: rgba(251,191,36,0.95); }
.recon-stat-card__label {
    font-size: 0.68rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(145,158,180,0.72);
}
.recon-stat-card__value {
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1.05;
    color: rgba(232,236,248,0.96);
    letter-spacing: -0.025em;
}
.recon-stat-card--good .recon-stat-card__value { color: rgba(134,239,172,0.95); }
.recon-stat-card--warn .recon-stat-card__value { color: rgba(252,211,77,0.92); }
.recon-stat-card--bad  .recon-stat-card__value { color: rgba(248,113,113,0.9); }
.recon-stat-card__sub {
    font-size: 0.71rem;
    color: rgba(135,148,170,0.6);
    margin-top: 1px;
}

/* ── Dashboard 2-col grid (funnel + insights) ─────────────────────────────── */
.recon-dashboard-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
    align-items: start;
}
@media (max-width: 820px) {
    .recon-dashboard-grid { grid-template-columns: 1fr; }
}

/* ── Charts 2-col grid ────────────────────────────────────────────────────── */
.recon-charts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
}
.recon-charts-grid > .recon-chart-section:only-child {
    grid-column: 1 / -1;
}
@media (max-width: 820px) {
    .recon-charts-grid { grid-template-columns: 1fr; }
}

/* ── Alert settings button ───────────────────────────────────────────────── */
.recon-alerts-settings-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 12px;
    background: rgba(99,102,241,0.12);
    border: 1px solid rgba(99,102,241,0.28);
    border-radius: 8px;
    color: rgba(165,168,255,0.9);
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    white-space: nowrap;
    flex-shrink: 0;
}
.recon-alerts-settings-btn:hover {
    background: rgba(99,102,241,0.22);
    border-color: rgba(99,102,241,0.5);
}

/* ── Notification bell ───────────────────────────────────────────────────── */
.notif-bell {
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
}
.notif-bell__btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 8px;
    color: rgba(180,190,210,0.75);
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.notif-bell__btn:hover {
    background: rgba(255,255,255,0.09);
    color: rgba(220,225,240,0.95);
    border-color: rgba(255,255,255,0.15);
}
.notif-bell__btn--active {
    color: rgba(252,211,77,0.9);
    border-color: rgba(252,211,77,0.3);
    background: rgba(252,211,77,0.07);
}
.notif-bell__badge {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 16px;
    height: 16px;
    padding: 0 3px;
    background: #ef4444;
    border-radius: 9px;
    font-size: 0.6rem;
    font-weight: 700;
    color: #fff;
    line-height: 16px;
    text-align: center;
    pointer-events: none;
}

/* ── Notification dropdown ───────────────────────────────────────────────── */
.notif-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 320px;
    max-height: 420px;
    background: rgba(18,22,36,0.97);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 14px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    z-index: 999;
    overflow: hidden;
}
.notif-dropdown__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 10px;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    flex-shrink: 0;
}
.notif-dropdown__title {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: rgba(180,190,215,0.7);
}
.notif-dropdown__mark-all {
    font-size: 0.71rem;
    color: rgba(99,102,241,0.9);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
}
.notif-dropdown__list {
    overflow-y: auto;
    flex: 1;
    padding: 6px 0;
}
.notif-dropdown__empty {
    margin: 0;
    padding: 16px;
    font-size: 0.78rem;
    color: rgba(155,165,185,0.65);
    line-height: 1.5;
}

/* ── Notification item ───────────────────────────────────────────────────── */
.notif-item {
    position: relative;
    padding: 10px 16px 10px 14px;
    border-left: 3px solid transparent;
    cursor: pointer;
    transition: background 0.12s;
}
.notif-item:hover { background: rgba(255,255,255,0.04); }
.notif-item--unread { background: rgba(99,102,241,0.05); }
.notif-item__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3px;
    gap: 8px;
}
.notif-item__type {
    font-size: 0.67rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
}
.notif-item__time {
    font-size: 0.67rem;
    color: rgba(130,140,165,0.6);
    flex-shrink: 0;
}
.notif-item__title {
    margin: 0;
    font-size: 0.8rem;
    color: rgba(215,220,235,0.88);
    line-height: 1.4;
}
.notif-item__dot {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #6366f1;
}

/* ── Alert settings modal ────────────────────────────────────────────────── */
.alert-settings-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(5,8,20,0.72);
    backdrop-filter: blur(4px);
    z-index: 1200;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 48px 16px;
    overflow-y: auto;
}
.alert-settings-modal {
    background: rgb(14,18,30);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 18px;
    box-shadow: 0 24px 72px rgba(0,0,0,0.7);
    width: 100%;
    max-width: 560px;
    padding: 28px 28px 32px;
    position: relative;
}
.alert-settings-modal__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 22px;
}
.alert-settings-modal__title {
    margin: 0 0 5px;
    font-size: 1.05rem;
    font-weight: 700;
    color: rgba(232,236,248,0.95);
}
.alert-settings-modal__sub {
    margin: 0;
    font-size: 0.8rem;
    color: rgba(150,160,185,0.75);
    line-height: 1.5;
}
.alert-settings-modal__close {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 8px;
    color: rgba(180,190,215,0.7);
    font-size: 1.1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.12s;
}
.alert-settings-modal__close:hover { background: rgba(255,255,255,0.1); }

/* channels section */
.alert-settings-channels {
    background: rgba(255,255,255,0.025);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 24px;
}
.alert-settings-channels__title {
    margin: 0 0 12px;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: rgba(140,150,175,0.7);
}
.alert-settings-channels__row {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.alert-settings-channels__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}
.alert-settings-channels__icon {
    font-size: 1rem;
    margin-top: 2px;
    flex-shrink: 0;
}
.alert-settings-channels__info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
}
.alert-settings-channels__name {
    font-size: 0.82rem;
    font-weight: 600;
    color: rgba(210,218,235,0.88);
}
.alert-settings-channels__status {
    font-size: 0.74rem;
    color: rgba(130,140,165,0.65);
}
.alert-settings-email-input {
    width: 100%;
    padding: 7px 10px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: rgba(210,218,235,0.9);
    font-size: 0.82rem;
    outline: none;
    transition: border-color 0.15s;
}
.alert-settings-email-input:focus { border-color: rgba(99,102,241,0.5); }
.alert-settings-push-btn {
    padding: 6px 12px;
    background: rgba(99,102,241,0.12);
    border: 1px solid rgba(99,102,241,0.3);
    border-radius: 8px;
    color: rgba(165,168,255,0.9);
    font-size: 0.77rem;
    font-weight: 600;
    cursor: pointer;
    width: fit-content;
    transition: background 0.15s;
}
.alert-settings-push-btn:hover { background: rgba(99,102,241,0.22); }
.alert-settings-push-btn--active {
    background: rgba(74,222,128,0.1);
    border-color: rgba(74,222,128,0.3);
    color: rgba(134,239,172,0.9);
}

/* alert rules */
.alert-settings-rules__title {
    margin: 0 0 12px;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: rgba(140,150,175,0.7);
}
.alert-settings-rules {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.alert-rule {
    background: rgba(255,255,255,0.025);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 11px;
    padding: 14px 16px;
    transition: border-color 0.15s, background 0.15s;
}
.alert-rule--enabled {
    border-color: rgba(99,102,241,0.25);
    background: rgba(99,102,241,0.04);
}
.alert-rule__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.alert-rule__toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}
.alert-rule__toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #6366f1;
    cursor: pointer;
    flex-shrink: 0;
}
.alert-rule__toggle-label {
    font-size: 0.84rem;
    font-weight: 600;
    color: rgba(210,218,235,0.9);
}
.alert-rule__threshold {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
}
.alert-rule__threshold-input {
    width: 72px;
    padding: 5px 8px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 7px;
    color: rgba(210,218,235,0.9);
    font-size: 0.82rem;
    text-align: right;
    outline: none;
    transition: border-color 0.15s;
}
.alert-rule__threshold-input:focus { border-color: rgba(99,102,241,0.5); }
.alert-rule__threshold-input:disabled { opacity: 0.4; }
.alert-rule__unit {
    font-size: 0.76rem;
    color: rgba(140,150,175,0.65);
    min-width: 24px;
}
.alert-rule__hint {
    margin: 6px 0 0;
    font-size: 0.74rem;
    color: rgba(130,140,165,0.65);
    line-height: 1.45;
}
.alert-rule__channels {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid rgba(255,255,255,0.06);
}
.alert-rule__channel-toggle {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.77rem;
    color: rgba(175,185,210,0.8);
    cursor: pointer;
}
.alert-rule__channel-toggle input[type="checkbox"] {
    width: 13px;
    height: 13px;
    accent-color: #6366f1;
    flex-shrink: 0;
}
.alert-rule__channel-note {
    font-size: 0.7rem;
    color: rgba(120,130,155,0.6);
    font-style: italic;
}

/* ── Cost by channel table ───────────────────────────────────────────────── */
.cost-by-channel {
    width: 100%;
}
.cost-by-channel__table-wrap {
    overflow-x: auto;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.07);
}
.cost-by-channel__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
}
.cost-by-channel__table th {
    padding: 9px 14px;
    background: rgba(255,255,255,0.03);
    color: rgba(140,152,178,0.72);
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: left;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    white-space: nowrap;
}
.cost-by-channel__table th.num,
.cost-by-channel__table td.num {
    text-align: right;
}
.cost-by-channel__table td {
    padding: 10px 14px;
    color: rgba(210,218,235,0.88);
    border-bottom: 1px solid rgba(255,255,255,0.04);
    vertical-align: middle;
    white-space: nowrap;
}
.cost-by-channel__table tbody tr:last-child td {
    border-bottom: none;
}
.cost-by-channel__table tbody tr:hover td {
    background: rgba(255,255,255,0.02);
}
.cost-by-channel__dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 7px;
    vertical-align: middle;
    flex-shrink: 0;
}
.cost-col {
    background: rgba(99,102,241,0.04);
}
.cost-by-channel__good { color: rgba(134,239,172,0.9) !important; }
.cost-by-channel__warn { color: rgba(252,211,77,0.85) !important; }
.cost-by-channel__bad  { color: rgba(248,113,113,0.85) !important; }
.cost-by-channel__avg-row td {
    border-top: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.025);
    color: rgba(175,185,210,0.75);
    font-size: 0.78rem;
}

/* ── Connect prompt (inline, below inputs bar) ───────────────────────────── */
.recon-connect-prompt {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 10px 0 4px;
}
.recon-connect-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 16px;
    background: linear-gradient(135deg, rgba(99,102,241,0.18) 0%, rgba(139,92,246,0.18) 100%);
    border: 1px solid rgba(99,102,241,0.4);
    border-radius: 9px;
    color: rgba(165,168,255,0.95);
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, opacity 0.15s;
    white-space: nowrap;
}
.recon-connect-btn::before {
    content: "→";
    font-size: 0.9rem;
}
.recon-connect-btn:hover {
    background: linear-gradient(135deg, rgba(99,102,241,0.28) 0%, rgba(139,92,246,0.28) 100%);
    border-color: rgba(99,102,241,0.65);
}
.recon-connect-btn:disabled { opacity: 0.55; cursor: wait; }
.recon-connect-prompt__hint {
    font-size: 0.75rem;
    color: rgba(130,140,165,0.65);
}

/* ── OAuth result banner ─────────────────────────────────────────────────── */
.oauth-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 18px;
    border-radius: 11px;
    margin-bottom: 16px;
    font-size: 0.83rem;
    font-weight: 500;
}
.oauth-banner--success {
    background: rgba(74,222,128,0.1);
    border: 1px solid rgba(74,222,128,0.28);
    color: rgba(134,239,172,0.95);
}
.oauth-banner--error {
    background: rgba(248,113,113,0.09);
    border: 1px solid rgba(248,113,113,0.3);
    color: rgba(252,165,165,0.95);
}
.oauth-banner__msg { flex: 1; }
.oauth-banner__close {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    color: inherit;
    opacity: 0.7;
    padding: 0 4px;
    line-height: 1;
}
.oauth-banner__close:hover { opacity: 1; }

/* ── Account picker modal ────────────────────────────────────────────────── */
.acct-picker-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(5,8,20,0.78);
    backdrop-filter: blur(5px);
    z-index: 1300;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}
.acct-picker-modal {
    background: rgb(14,18,30);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 18px;
    box-shadow: 0 28px 80px rgba(0,0,0,0.75);
    width: 100%;
    max-width: 480px;
    padding: 28px 28px 24px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}
.acct-picker-modal__header { margin-bottom: 18px; }
.acct-picker-modal__title {
    margin: 0 0 5px;
    font-size: 1.05rem;
    font-weight: 700;
    color: rgba(232,236,248,0.95);
}
.acct-picker-modal__sub {
    margin: 0;
    font-size: 0.8rem;
    color: rgba(150,160,185,0.75);
}
.acct-picker-modal__loading,
.acct-picker-modal__empty {
    margin: 0 0 16px;
    font-size: 0.82rem;
    color: rgba(150,160,185,0.7);
}
.acct-picker-modal__error {
    margin: 0 0 16px;
    font-size: 0.82rem;
    color: rgba(252,165,165,0.9);
    background: rgba(248,113,113,0.08);
    border: 1px solid rgba(248,113,113,0.2);
    border-radius: 8px;
    padding: 10px 14px;
}
.acct-picker-list {
    list-style: none;
    margin: 0 0 16px;
    padding: 0;
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.acct-picker-item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 13px 16px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 11px;
    text-align: left;
    cursor: pointer;
    transition: background 0.13s, border-color 0.13s;
}
.acct-picker-item:hover:not(:disabled) {
    background: rgba(99,102,241,0.1);
    border-color: rgba(99,102,241,0.35);
}
.acct-picker-item:disabled { opacity: 0.5; cursor: wait; }
.acct-picker-item__name {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(218,224,240,0.95);
    flex: 1;
}
.acct-picker-item__meta {
    font-size: 0.72rem;
    color: rgba(130,140,165,0.65);
    white-space: nowrap;
}
.acct-picker-item__arrow {
    flex-shrink: 0;
    color: rgba(99,102,241,0.6);
}
.acct-picker-modal__cancel {
    width: 100%;
    padding: 10px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 9px;
    color: rgba(155,165,190,0.7);
    font-size: 0.82rem;
    cursor: pointer;
    transition: background 0.13s;
    flex-shrink: 0;
}
.acct-picker-modal__cancel:hover { background: rgba(255,255,255,0.08); }


/* ── Ad Performance panel (Channel Analytics) ──────────────────────────────── */
.ca-ad-perf {
    margin: 0 0 18px;
}
.ca-ad-perf__title {
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(155,165,190,0.55);
    margin: 0 0 10px;
}
.ca-ad-perf__cards {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
.ca-ad-perf-card {
    flex: 1 1 220px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.ca-ad-perf-card__platform {
    font-size: 0.82rem;
    font-weight: 600;
    color: rgba(200,210,230,0.85);
}
.ca-ad-perf-card__metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
}
.ca-ad-perf-card__metric {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.ca-ad-perf-card__val {
    font-size: 0.92rem;
    font-weight: 700;
    color: rgba(220,225,240,0.9);
    font-variant-numeric: tabular-nums;
}
.ca-ad-perf-card__lbl {
    font-size: 0.7rem;
    color: rgba(130,140,165,0.6);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}
.ca-ad-perf-card__metric--accent .ca-ad-perf-card__val {
    color: rgba(192,159,83,0.95);
}
.ca-ad-perf-card__metric--accent .ca-ad-perf-card__lbl {
    color: rgba(192,159,83,0.5);
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Reports/MarketingReport/MarketingReport.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,uFAAuF;AAC3F;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,4BAA4B;IAC5B,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,mCAAmC;IACnC,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;IAC5B,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,8BAA8B;IAC9B,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;IAClC,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,kCAAkC;IAClC,oBAAoB;IACpB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;;;;;;;EAOE;AACF;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,yFAAyF;AAC7F;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;EAGE;AACF;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;;;;;EAOE;;AAEF;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,yFAAyF;IACzF,0CAA0C;IAC1C,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,yFAAyF;AAC7F;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;;;EAME;;AAEF;IACI,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;;;;;EAOE;;AAEF;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;;IAEI,6BAA6B;IAC7B,gGAAgG;IAChG,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;;;;;;;;EAQE;;AAEF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;AACL;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb;;6BAEyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,yDAA+R;IAC/R,4BAA4B;IAC5B,qCAAqC;IACrC,eAAe;AACnB;;AAEA;;IAEI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf;;wBAEoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,2CAA2C;IAC3C,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;;;EAGE;AACF;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;IACvC;;;;KAIC;AACL;;AAEA;IACI,sCAAsC;IACtC;;;;KAIC;AACL;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,+CAA+C;AACnD;;AAEA;;;;;;;EAOE;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;QACnB,qBAAqB;QACrB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;IAC7B,6DAA6D;IAC7D,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf;;;0BAGsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf;;;6BAGyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,4CAA4C;IAC5C,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,qCAAqC;IACrC,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,+BAA+B;IAC/B,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf;;;6BAGyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;;;;;;;;;EASE;AACF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;EAOE;;AAEF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC;;;;KAIC;IACD,sCAAsC;AAC1C;;AAEA;;;;;EAKE;;AAEF;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;;;;;EAKE;;AAEF;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;;;;;;;;;EASE;;AAEF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB;;;;KAIC;IACD,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,sCAAsC;IACtC,2CAA2C;IAC3C,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C;;;;KAIC;AACL;;AAEA;IACI,2CAA2C;IAC3C;;;;KAIC;AACL;;AAEA;IACI,4CAA4C;IAC5C;;;;KAIC;AACL;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B;;;;KAIC;IACD,kBAAkB;IAClB,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,4EAA4E;AAChF;;AAEA;;IAEI,uCAAuC;IACvC,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,4EAA4E;AAC5E;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,gFAAgF;;AAEhF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,6CAA6C;IAC7C,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,iFAAiF;;AAEjF;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,iFAAiF;;AAEjF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA,iEAAiE;AACjE;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,OAAO;IACP,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;AACzB;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA,iEAAiE;AACjE;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,MAAM;IACN,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;AACA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA,iEAAiE;AACjE;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,mCAAmC;AACvC;AACA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA,iEAAiE;AACjE;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,uBAAuB;IACvB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6EAA6E;AAC7E;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gDAAgD;IAChD,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,sCAAsC,mBAAmB,EAAE;AAC3D,sCAAsC,mBAAmB,EAAE;AAC3D;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;AACA,4BAA4B,gBAAgB,EAAE;AAC9C,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;AAC9D;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,8EAA8E;AAC9E;IACI,SAAS;IACT,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,kCAAkC;IAClC,wCAAwC;AAC5C;AACA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;AAC9B;AACA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,0BAA0B;AAC9B;AACA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,0BAA0B;AAC9B;AACA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,0BAA0B;AAC9B;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;AACA,gDAAgD,cAAc,EAAE;AAChE,gDAAgD,cAAc,EAAE;AAChE,mDAAmD,cAAc,EAAE;AACnE,gDAAgD,cAAc,EAAE;AAChE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;IACT,iBAAiB;AACrB;;AAEA,8EAA8E;AAC9E;IACI,SAAS;IACT,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;gFAEgF;;AAEhF;IACI,oBAAoB;AACxB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;AACnD;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,4BAA4B;AAChC;;AAEA,gFAAgF;AAChF;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,iBAAiB,qCAAqC,EAAE;AAC5D;AACA;IACI,iBAAiB,8BAA8B,EAAE;AACrD;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;AACA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;AACA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;AACA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;AACA,gDAAgD,4BAA4B,EAAE;AAC9E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,wBAAwB;AAC5B;AACA,iDAAiD,6BAA6B,EAAE;AAChF,iDAAiD,4BAA4B,EAAE;AAC/E,iDAAiD,4BAA4B,EAAE;AAC/E;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,wBAAwB,0BAA0B,EAAE;AACxD;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB,0BAA0B,EAAE;AACrD;;AAEA,+EAA+E;AAC/E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iCAAiC;IACjC,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,6DAA6D;AACjE;AACA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,+CAA+C;IAC/C,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,OAAO;IACP,cAAc;AAClB;AACA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;IAClC,eAAe;IACf,4BAA4B;AAChC;AACA,oBAAoB,kCAAkC,EAAE;AACxD,sBAAsB,iCAAiC,EAAE;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;AAClB;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,+EAA+E;AAC/E;IACI,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;AACA,qCAAqC,iCAAiC,EAAE;;AAExE,qBAAqB;AACrB;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;AACA,oCAAoC,kCAAkC,EAAE;AACxE;IACI,iBAAiB;IACjB,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;AACA,iCAAiC,iCAAiC,EAAE;AACpE;IACI,gCAAgC;IAChC,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;AACA;IACI,mCAAmC;IACnC,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;AACA,qCAAqC,kCAAkC,EAAE;AACzE,wCAAwC,YAAY,EAAE;AACtD;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA,+EAA+E;AAC/E;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;AACvB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,+CAA+C;IAC/C,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,iCAAiC;AACrC;AACA,yBAAyB,uCAAuC,EAAE;AAClE,yBAAyB,uCAAuC,EAAE;AAClE,yBAAyB,wCAAwC,EAAE;AACnE;IACI,4CAA4C;IAC5C,mCAAmC;IACnC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yFAAyF;IACzF,sCAAsC;IACtC,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+DAA+D;IAC/D,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,yFAAyF;IACzF,mCAAmC;AACvC;AACA,8BAA8B,aAAa,EAAE,YAAY,EAAE;AAC3D;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,6BAA6B;AACjC;AACA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,6BAA6B;AACjC;AACA,qBAAqB,OAAO,EAAE;AAC9B;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;AACA,6BAA6B,UAAU,EAAE;;AAEzC,+EAA+E;AAC/E;IACI,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;AACA,6BAA6B,mBAAmB,EAAE;AAClD;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;AACA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;AACpD;AACA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;AACA,6BAA6B,YAAY,EAAE,YAAY,EAAE;AACzD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,cAAc;AAClB;AACA,mCAAmC,kCAAkC,EAAE;;;AAGvE,iFAAiF;AACjF;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;AAC/B","sourcesContent":[".marketing-report-page {\n    padding-bottom: 48px;\n}\n\n.marketing-report-hero {\n    margin: 0 0 20px;\n}\n\n.marketing-report-hero h1 {\n    margin: 0 0 8px;\n    font-size: 1.35rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n}\n\n.marketing-report-hero p,\n.marketing-report-hero__lede {\n    margin: 0;\n    max-width: 52rem;\n    font-size: 0.875rem;\n    line-height: 1.55;\n    color: rgba(200, 200, 205, 0.9);\n}\n\n.marketing-report-section {\n    margin-bottom: 28px;\n}\n\n.marketing-report-section__title {\n    margin: 0 0 6px;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.92);\n}\n\n.marketing-report-section__hint {\n    margin: 0 0 14px;\n    max-width: 44rem;\n    font-size: 0.78rem;\n    line-height: 1.45;\n    color: rgba(165, 165, 175, 0.9);\n}\n\n.marketing-highlights {\n    margin-bottom: 28px;\n    padding: 18px 18px 20px;\n    border-radius: 14px;\n    border: 1px solid rgba(192, 159, 83, 0.24);\n    background: linear-gradient(155deg, rgba(192, 159, 83, 0.1) 0%, rgba(0, 0, 0, 0.2) 55%);\n}\n\n.marketing-highlights__h2 {\n    margin-bottom: 10px;\n}\n\n.marketing-highlights__eyebrow {\n    margin: 0 0 6px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.88);\n}\n\n.marketing-highlights__headline {\n    margin: 0 0 8px;\n    font-size: 1.2rem;\n    font-weight: 600;\n    line-height: 1.35;\n    color: rgba(245, 243, 238, 0.98);\n}\n\n.marketing-highlights__sub {\n    margin: 0 0 16px;\n    max-width: 44rem;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: rgba(185, 185, 192, 0.92);\n}\n\n.marketing-highlights__list {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: grid;\n    gap: 10px;\n}\n\n.marketing-highlights__item {\n    margin: 0;\n    padding: 12px 14px 12px 16px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.22);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-left-width: 3px;\n}\n\n.marketing-highlights__item--spotlight {\n    border-left-color: rgba(192, 159, 83, 0.95);\n}\n\n.marketing-highlights__item--win {\n    border-left-color: rgba(110, 185, 130, 0.9);\n}\n\n.marketing-highlights__item--watch {\n    border-left-color: rgba(220, 145, 115, 0.9);\n}\n\n.marketing-highlights__item--data {\n    border-left-color: rgba(140, 155, 190, 0.75);\n}\n\n.marketing-highlights__item-title {\n    display: block;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba(210, 205, 195, 0.95);\n    margin-bottom: 6px;\n}\n\n.marketing-highlights__item-body {\n    margin: 0;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: rgba(225, 225, 228, 0.94);\n}\n\n.marketing-report-banner {\n    margin-bottom: 20px;\n    padding: 12px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(192, 159, 83, 0.28);\n    background: rgba(192, 159, 83, 0.08);\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    color: rgba(230, 225, 210, 0.95);\n}\n\n.marketing-report-summary {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 12px;\n    margin-bottom: 22px;\n}\n\n.marketing-report-kpi {\n    padding: 14px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.22);\n}\n\n.marketing-report-kpi__label {\n    display: block;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.9);\n    margin-bottom: 6px;\n}\n\n.marketing-report-kpi__hint {\n    margin: 6px 0 0;\n    font-size: 0.7rem;\n    line-height: 1.4;\n    color: rgba(155, 155, 165, 0.95);\n    font-weight: 400;\n}\n\n.marketing-report-kpi__value {\n    font-size: 1.15rem;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: #f4f4f4;\n}\n\n.marketing-report-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.marketing-report-toolbar__left {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.marketing-report-toolbar__placeholder {\n    flex: 0 0 auto;\n    min-width: 1px;\n}\n\n.marketing-report-back {\n    flex: 0 0 auto;\n    margin: 0;\n    padding: 6px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.1);\n    color: rgba(230, 220, 195, 0.98);\n    font-size: 0.8125rem;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.marketing-report-back:hover {\n    background: rgba(192, 159, 83, 0.18);\n    border-color: rgba(192, 159, 83, 0.5);\n}\n\n.marketing-report-toolbar__meta {\n    margin-left: auto;\n    font-size: 0.78rem;\n    color: rgba(180, 180, 188, 0.9);\n    text-align: right;\n}\n\n.marketing-report-export {\n    margin: 0;\n    padding: 6px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(230, 230, 232, 0.96);\n    font-size: 0.78rem;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.marketing-report-export:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.22);\n}\n\n.marketing-report-export--secondary {\n    border-color: rgba(192, 159, 83, 0.22);\n    background: rgba(192, 159, 83, 0.06);\n    color: rgba(230, 220, 200, 0.95);\n}\n\n.marketing-report-export--secondary:hover {\n    background: rgba(192, 159, 83, 0.12);\n    border-color: rgba(192, 159, 83, 0.35);\n}\n\n.marketing-report-drill-title {\n    margin: 0 0 12px;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: rgba(235, 232, 225, 0.98);\n}\n\n.marketing-report-table-wrap {\n    overflow-x: auto;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.18);\n}\n\n.marketing-report-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.8125rem;\n}\n\n.marketing-report-table th,\n.marketing-report-table td {\n    padding: 10px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.marketing-report-table th {\n    font-weight: 600;\n    color: rgba(192, 159, 83, 0.92);\n    white-space: nowrap;\n    background: rgba(0, 0, 0, 0.25);\n}\n\n.marketing-report-table td {\n    color: rgba(230, 230, 232, 0.95);\n    font-variant-numeric: tabular-nums;\n}\n\n.marketing-report-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.marketing-report-table tbody tr:hover td {\n    background: rgba(255, 255, 255, 0.03);\n}\n\n.marketing-report-table__row--clickable {\n    cursor: pointer;\n}\n\n.marketing-report-table__row--clickable:hover td {\n    background: rgba(192, 159, 83, 0.07);\n}\n\n.marketing-report-table__row--clickable:focus {\n    outline: none;\n}\n\n.marketing-report-table__row--clickable:focus-visible td:first-child {\n    box-shadow: inset 3px 0 0 0 rgba(192, 159, 83, 0.85);\n}\n\n.marketing-report-channel-cell {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.marketing-report-channel-cell__label {\n    flex: 1;\n    min-width: 0;\n}\n\n.marketing-report-channel-cell__chevron {\n    flex-shrink: 0;\n    font-size: 0.9rem;\n    color: rgba(192, 159, 83, 0.75);\n}\n\n.marketing-report-table__empty-row {\n    text-align: center;\n    font-variant-numeric: normal;\n    color: rgba(180, 180, 188, 0.88);\n}\n\n.marketing-report-table--with-choices {\n    font-size: 0.78rem;\n}\n\n.marketing-report-table__col-choice {\n    min-width: 6.75rem;\n    max-width: 9.5rem;\n    white-space: normal;\n    text-align: right !important;\n    font-variant-numeric: tabular-nums;\n    line-height: 1.35;\n}\n\n.marketing-report-table th.marketing-report-table__col-choice {\n    text-align: right;\n    white-space: normal;\n    line-height: 1.25;\n}\n\n.marketing-report-footnote {\n    margin: 10px 0 0;\n    max-width: 52rem;\n    font-size: 0.75rem;\n    line-height: 1.45;\n    color: rgba(165, 165, 175, 0.92);\n}\n\n.marketing-report-table__col-channel {\n    min-width: 10.5rem;\n    max-width: 14rem;\n    white-space: normal;\n}\n\n.marketing-report-table__col-campaign {\n    min-width: 12rem;\n    max-width: 28rem;\n    white-space: normal;\n    word-break: break-word;\n    font-variant-numeric: normal;\n}\n\n.marketing-report-table__col-num {\n    width: 1%;\n    white-space: nowrap;\n    text-align: right;\n}\n\n.marketing-report-table th.marketing-report-table__col-num {\n    text-align: right;\n}\n\n.marketing-report-th-inner {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n    justify-content: flex-start;\n}\n\n.marketing-report-table th.marketing-report-table__col-num .marketing-report-th-inner,\n.marketing-report-table th.marketing-report-table__col-choice .marketing-report-th-inner {\n    justify-content: flex-end;\n}\n\n.marketing-report-th-label {\n    min-width: 0;\n}\n\n.marketing-report-col-sort {\n    flex-shrink: 0;\n    margin: 0;\n    padding: 2px 6px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    background: rgba(0, 0, 0, 0.2);\n    color: rgba(175, 175, 185, 0.95);\n    font-size: 0.65rem;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.02em;\n    line-height: 1.2;\n    cursor: pointer;\n}\n\n.marketing-report-col-sort:hover {\n    border-color: rgba(192, 159, 83, 0.45);\n    color: rgba(235, 228, 210, 0.98);\n    background: rgba(192, 159, 83, 0.1);\n}\n\n.marketing-report-col-sort--active {\n    border-color: rgba(192, 159, 83, 0.55);\n    color: rgba(240, 232, 210, 0.98);\n    background: rgba(192, 159, 83, 0.14);\n}\n\n.marketing-report-empty {\n    padding: 28px 16px;\n    text-align: center;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: rgba(180, 180, 188, 0.88);\n}\n\n.marketing-report-error {\n    padding: 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 120, 120, 0.35);\n    background: rgba(80, 20, 20, 0.25);\n    color: rgba(255, 200, 200, 0.95);\n    font-size: 0.875rem;\n    margin-bottom: 16px;\n}\n\n.marketing-report-code {\n    margin-top: 10px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.35);\n    font-size: 0.72rem;\n    overflow-x: auto;\n    color: rgba(220, 220, 225, 0.9);\n}\n\n.marketing-context {\n    margin-bottom: 18px;\n    padding: 14px 16px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.marketing-context--empty {\n    border-style: dashed;\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n.marketing-context__title {\n    margin: 0 0 6px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: rgba(235, 232, 225, 0.98);\n}\n\n.marketing-context__lede {\n    margin: 0 0 14px;\n    max-width: 48rem;\n    font-size: 0.75rem;\n    line-height: 1.45;\n    color: rgba(175, 175, 185, 0.92);\n}\n\n.marketing-context__empty-note {\n    margin: 0;\n    max-width: 48rem;\n    font-size: 0.78rem;\n    line-height: 1.45;\n    color: rgba(175, 175, 185, 0.9);\n}\n\n.marketing-context__empty-note code {\n    font-size: 0.72rem;\n    color: rgba(210, 195, 160, 0.95);\n}\n\n.marketing-context__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n    gap: 16px;\n    align-items: start;\n}\n\n.marketing-context__block-title {\n    margin: 0 0 8px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.88);\n}\n\n.marketing-context__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.72rem;\n}\n\n.marketing-context__table th,\n.marketing-context__table td {\n    padding: 6px 8px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    vertical-align: top;\n}\n\n.marketing-context__table th {\n    font-weight: 600;\n    color: rgba(192, 159, 83, 0.85);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.marketing-context__label {\n    word-break: break-word;\n    font-variant-numeric: normal;\n    color: rgba(230, 230, 232, 0.95);\n}\n\n.marketing-context__num {\n    text-align: right;\n    white-space: nowrap;\n    font-variant-numeric: tabular-nums;\n}\n\n.marketing-context__split {\n    font-size: 0.68rem;\n    line-height: 1.35;\n    color: rgba(195, 195, 200, 0.9);\n    font-variant-numeric: tabular-nums;\n}\n\n.marketing-report-compare-banner {\n    margin: 12px 0 0;\n    max-width: 52rem;\n    font-size: 0.8125rem;\n    line-height: 1.5;\n    color: rgba(210, 200, 175, 0.95);\n}\n\n.marketing-report-compare-warning {\n    margin: 10px 0 0;\n    max-width: 52rem;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid rgba(220, 150, 100, 0.35);\n    background: rgba(60, 30, 15, 0.35);\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    color: rgba(255, 210, 185, 0.96);\n}\n\n.marketing-report-kpi__compare {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.72rem;\n    font-weight: 500;\n    line-height: 1.35;\n}\n\n.marketing-report-cell-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 3px;\n}\n\n.marketing-report-table__col-campaign .marketing-report-cell-stack {\n    align-items: flex-start;\n}\n\n.marketing-report-cell-stack__primary {\n    font-variant-numeric: tabular-nums;\n}\n\n.marketing-report-cell-stack__compare {\n    font-size: 0.68rem;\n    line-height: 1.25;\n    font-variant-numeric: tabular-nums;\n}\n\n.marketing-report-delta {\n    font-weight: 600;\n    letter-spacing: 0.01em;\n}\n\n.marketing-report-delta--up {\n    color: rgba(130, 205, 155, 0.95);\n}\n\n.marketing-report-delta--down {\n    color: rgba(235, 145, 125, 0.95);\n}\n\n.marketing-report-delta--flat {\n    color: rgba(175, 175, 185, 0.9);\n}\n\n.marketing-report-delta--new {\n    font-weight: 500;\n    color: rgba(160, 185, 220, 0.92);\n}\n\n/*\n * Marketing dashboard chart strip.\n *\n * The overview view shows two cards side-by-side (choice mix donut +\n * channels bar). The channel drill-down shows five cards: a wide one for\n * \"top campaigns\" and four half-width for mix, acceptance %, countries,\n * and paths. On narrow screens everything collapses to a single column.\n */\n.marketing-charts {\n    margin-bottom: 28px;\n}\n\n.marketing-charts__grid {\n    display: grid;\n    gap: 16px;\n}\n\n.marketing-charts__grid--two-up {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.marketing-charts__grid--three-up {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 1200px) {\n    .marketing-charts__grid--three-up {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 820px) {\n    .marketing-charts__grid--two-up,\n    .marketing-charts__grid--three-up {\n        grid-template-columns: 1fr;\n    }\n}\n\n.marketing-charts__card {\n    display: flex;\n    flex-direction: column;\n    min-height: 280px;\n    padding: 14px 16px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(192, 159, 83, 0.18);\n    background: linear-gradient(155deg, rgba(192, 159, 83, 0.06) 0%, rgba(0, 0, 0, 0.22) 60%);\n}\n\n.marketing-charts__card--wide {\n    grid-column: span 2;\n}\n\n@media (max-width: 1200px) {\n    .marketing-charts__card--wide {\n        grid-column: span 2;\n    }\n}\n\n@media (max-width: 820px) {\n    .marketing-charts__card--wide {\n        grid-column: span 1;\n    }\n}\n\n.marketing-charts__card-header {\n    margin-bottom: 8px;\n}\n\n.marketing-charts__card-title {\n    margin: 0 0 4px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(245, 243, 238, 0.96);\n}\n\n.marketing-charts__card-sub {\n    margin: 0;\n    font-size: 0.74rem;\n    line-height: 1.4;\n    color: rgba(170, 170, 180, 0.9);\n}\n\n.marketing-charts__card-body {\n    flex: 1;\n    min-height: 220px;\n    position: relative;\n}\n\n/*\n * AnyChart's pie/bar containers need an explicit height; the inner chart\n * renders into a block element inside <div class=\"chart\">.\n */\n.marketing-charts__card-body .widget {\n    height: 100%;\n    min-height: 220px;\n}\n\n.marketing-charts__card-body .chart {\n    width: 100%;\n    min-height: 220px;\n}\n\n.marketing-charts__empty {\n    margin: 0;\n    padding: 18px 14px;\n    font-size: 0.82rem;\n    line-height: 1.5;\n    color: rgba(170, 170, 180, 0.88);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px dashed rgba(192, 159, 83, 0.24);\n}\n\n.marketing-charts__card--timeseries {\n    margin-top: 0;\n}\n\n.marketing-charts__card-body--tall {\n    min-height: 350px;\n}\n\n.marketing-charts__card-body--tall .widget,\n.marketing-charts__card-body--tall .chart {\n    min-height: 350px;\n}\n\n/*\n * --- Visibility reframe --------------------------------------------------\n *\n * The \"analytics-invisible traffic\" narrative and supporting cues.\n * Color palette stays in the platform gold/amber family so the warning\n * reads as \"pay attention\" rather than \"something is broken\" — this is a\n * product-level insight, not an error state.\n */\n\n.marketing-report-visibility-narrative {\n    margin: 4px 0 16px;\n    padding: 12px 14px 13px;\n    max-width: 62rem;\n    font-size: 0.85rem;\n    line-height: 1.55;\n    color: rgba(240, 230, 205, 0.95);\n    background: linear-gradient(155deg, rgba(210, 165, 80, 0.12) 0%, rgba(0, 0, 0, 0.25) 65%);\n    border: 1px solid rgba(210, 165, 80, 0.28);\n    border-left: 3px solid rgba(210, 165, 80, 0.82);\n    border-radius: 10px;\n}\n\n.marketing-report-visibility-narrative strong {\n    color: rgba(255, 235, 195, 1);\n    font-weight: 600;\n}\n\n.marketing-report-kpi--warn {\n    border-color: rgba(210, 165, 80, 0.45);\n    background: linear-gradient(155deg, rgba(210, 165, 80, 0.12) 0%, rgba(0, 0, 0, 0.24) 60%);\n}\n\n.marketing-report-kpi--warn .marketing-report-kpi__label {\n    color: rgba(235, 205, 145, 0.92);\n}\n\n.marketing-report-kpi--warn .marketing-report-kpi__value {\n    color: rgba(255, 235, 195, 1);\n}\n\n/*\n * Per-row \"analytics blind spot\" highlight.\n *\n * A faint amber tint + a thick leading border drawn via a box-shadow\n * inset so it doesn't shift row layout. The badge sits next to the\n * campaign / channel name in lowercase to read as a label, not a button.\n */\n\n.marketing-report-table__row--blind-spot {\n    background: rgba(210, 165, 80, 0.06);\n    box-shadow: inset 3px 0 0 0 rgba(210, 165, 80, 0.6);\n}\n\n.marketing-report-table__row--blind-spot.marketing-report-table__row--clickable:hover,\n.marketing-report-table__row--blind-spot:hover {\n    background: rgba(210, 165, 80, 0.12);\n}\n\n.marketing-report-blind-spot-badge {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    padding: 2px 8px;\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: lowercase;\n    color: rgba(255, 225, 170, 0.98);\n    background: rgba(210, 165, 80, 0.18);\n    border: 1px solid rgba(210, 165, 80, 0.45);\n    border-radius: 999px;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n/*\n * --- Channels table pagination -----------------------------------------\n *\n * Compact pager shown under the overview table so the list never grows\n * past ten rows. Prev/Next buttons sit to either side of the numbered\n * pages; ellipsis gaps compress long page lists. Meta text reports the\n * window so totals stay visible without the user opening the CSV export.\n */\n\n.marketing-report-pagination {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: 6px 10px;\n    margin-top: 14px;\n    padding: 18px 8px 14px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.marketing-report-pagination__btn {\n    padding: 7px 12px;\n    font-size: 0.8rem;\n    font-family: inherit;\n    color: rgba(225, 225, 230, 0.94);\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    border-radius: 7px;\n    cursor: pointer;\n    transition: border-color 120ms ease, color 120ms ease, background 120ms ease;\n}\n\n.marketing-report-pagination__btn:hover:not(:disabled) {\n    border-color: rgba(210, 165, 80, 0.55);\n    color: rgba(255, 225, 170, 0.98);\n    background: rgba(210, 165, 80, 0.08);\n}\n\n.marketing-report-pagination__btn:focus-visible {\n    outline: 2px solid rgba(210, 165, 80, 0.7);\n    outline-offset: 2px;\n}\n\n.marketing-report-pagination__btn:disabled {\n    opacity: 0.38;\n    cursor: not-allowed;\n}\n\n.marketing-report-pagination__pages {\n    display: flex;\n    gap: 4px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.marketing-report-pagination__page {\n    min-width: 34px;\n    padding: 7px 10px;\n    font-size: 0.8rem;\n    font-family: inherit;\n    color: rgba(225, 225, 230, 0.88);\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 7px;\n    cursor: pointer;\n    transition: background 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n\n.marketing-report-pagination__page:hover {\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(255, 225, 170, 0.98);\n}\n\n.marketing-report-pagination__page:focus-visible {\n    outline: 2px solid rgba(210, 165, 80, 0.7);\n    outline-offset: 2px;\n}\n\n.marketing-report-pagination__page--active,\n.marketing-report-pagination__page--active:hover {\n    color: rgba(20, 18, 12, 0.96);\n    background: linear-gradient(155deg, rgba(216, 181, 106, 0.96) 0%, rgba(184, 141, 60, 0.96) 100%);\n    border-color: rgba(192, 159, 83, 0.65);\n    font-weight: 600;\n    cursor: default;\n}\n\n.marketing-report-pagination__gap {\n    padding: 7px 2px;\n    color: rgba(160, 160, 170, 0.7);\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n.marketing-report-pagination__meta {\n    flex-basis: 100%;\n    margin-top: 2px;\n    font-size: 0.76rem;\n    line-height: 1.4;\n    color: rgba(180, 180, 190, 0.86);\n    text-align: center;\n}\n\n.marketing-report-pagination__meta strong {\n    color: rgba(230, 230, 235, 0.95);\n    font-weight: 600;\n}\n\n@media (min-width: 720px) {\n    .marketing-report-pagination__meta {\n        flex-basis: auto;\n        margin-top: 0;\n        margin-left: 12px;\n        text-align: left;\n    }\n}\n\n/*\n * --- Ad-platform reconciliation panel ----------------------------------\n *\n * Sits between the KPI grid and the chart strip. Inputs stack responsively;\n * result cards flow in a 3–4 column grid on wide screens, collapsing to a\n * single column on phones. The \"good\" and \"warn\" tones match the rest of\n * the dashboard's palette (green accents for visibility, gold/amber for the\n * invisible-gap card).\n */\n\n.marketing-reconciliation {\n    margin: 0 0 28px;\n    padding: 18px 18px 20px;\n    border-radius: 14px;\n    border: 1px solid rgba(192, 159, 83, 0.24);\n    background: linear-gradient(\n        155deg,\n        rgba(192, 159, 83, 0.08) 0%,\n        rgba(0, 0, 0, 0.22) 65%\n    );\n}\n\n.marketing-reconciliation__header {\n    margin-bottom: 14px;\n}\n\n.marketing-reconciliation__inputs {\n    display: grid;\n    grid-template-columns: 1.2fr 1fr 1fr auto;\n    gap: 12px 14px;\n    align-items: end;\n    margin-bottom: 8px;\n}\n\n@media (max-width: 900px) {\n    .marketing-reconciliation__inputs {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@media (max-width: 540px) {\n    .marketing-reconciliation__inputs {\n        grid-template-columns: 1fr;\n    }\n}\n\n.marketing-reconciliation__field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    min-width: 0;\n}\n\n.marketing-reconciliation__field-label {\n    font-size: 0.74rem;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    color: rgba(195, 195, 205, 0.86);\n}\n\n.marketing-reconciliation__input,\n.marketing-reconciliation__select {\n    width: 100%;\n    height: 38px;\n    padding: 0 11px;\n    box-sizing: border-box;\n    font-size: 0.88rem;\n    font-family: inherit;\n    color: rgba(245, 243, 238, 0.98);\n    background: rgba(0, 0, 0, 0.28);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    border-radius: 8px;\n    outline: none;\n    transition:\n        border-color 120ms ease,\n        background 120ms ease;\n}\n\n.marketing-reconciliation__select {\n    -webkit-appearance: none;\n    appearance: none;\n    padding-right: 28px;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='rgba(180,185,200,0.7)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 9px center;\n    cursor: pointer;\n}\n\n.marketing-reconciliation__input:focus,\n.marketing-reconciliation__select:focus {\n    border-color: rgba(192, 159, 83, 0.6);\n    background: rgba(0, 0, 0, 0.38);\n}\n\n.marketing-reconciliation__money {\n    display: flex;\n    gap: 6px;\n    min-width: 0;\n}\n\n.marketing-reconciliation__input--money {\n    flex: 1;\n    min-width: 0;\n}\n\n.marketing-reconciliation__select--currency {\n    flex: 0 0 auto;\n    width: 88px;\n}\n\n.marketing-reconciliation__actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n}\n\n.marketing-reconciliation__clear {\n    padding: 9px 14px;\n    font-size: 0.82rem;\n    font-family: inherit;\n    color: rgba(215, 215, 220, 0.94);\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    border-radius: 8px;\n    cursor: pointer;\n    transition:\n        border-color 120ms ease,\n        color 120ms ease;\n}\n\n.marketing-reconciliation__clear:hover {\n    border-color: rgba(210, 165, 80, 0.5);\n    color: rgba(255, 225, 170, 0.98);\n}\n\n.marketing-reconciliation__window-hint {\n    margin: 2px 0 16px;\n    font-size: 0.76rem;\n    line-height: 1.5;\n    color: rgba(160, 160, 170, 0.88);\n}\n\n.marketing-reconciliation__empty {\n    padding: 18px 16px;\n    font-size: 0.88rem;\n    line-height: 1.55;\n    color: rgba(185, 185, 195, 0.92);\n    border: 1px dashed rgba(192, 159, 83, 0.28);\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.12);\n}\n\n.marketing-reconciliation__empty strong {\n    color: rgba(245, 243, 238, 0.98);\n    font-weight: 600;\n}\n\n/*\n * Result grid: 4-up on wide desktops (three reconciliation cards + cost\n * card when spend is entered), graceful fallback to 2-up and 1-up.\n */\n.marketing-reconciliation__results {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 12px;\n    margin-top: 4px;\n}\n\n.marketing-reconciliation__result {\n    padding: 14px 14px 15px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(255, 255, 255, 0.035);\n}\n\n.marketing-reconciliation__result--good {\n    border-color: rgba(140, 200, 130, 0.35);\n    background: linear-gradient(\n        155deg,\n        rgba(140, 200, 130, 0.12) 0%,\n        rgba(0, 0, 0, 0.25) 60%\n    );\n}\n\n.marketing-reconciliation__result--warn {\n    border-color: rgba(210, 165, 80, 0.45);\n    background: linear-gradient(\n        155deg,\n        rgba(210, 165, 80, 0.14) 0%,\n        rgba(0, 0, 0, 0.25) 60%\n    );\n}\n\n.marketing-reconciliation__result-title {\n    margin: 0 0 6px;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(195, 195, 205, 0.92);\n}\n\n.marketing-reconciliation__result--good .marketing-reconciliation__result-title {\n    color: rgba(175, 220, 165, 0.95);\n}\n\n.marketing-reconciliation__result--warn .marketing-reconciliation__result-title {\n    color: rgba(235, 200, 140, 0.95);\n}\n\n.marketing-reconciliation__result-headline {\n    margin: 0 0 6px;\n    font-size: 1.3rem;\n    font-weight: 600;\n    line-height: 1.25;\n    color: rgba(245, 243, 238, 0.98);\n}\n\n.marketing-reconciliation__result-detail {\n    margin: 0;\n    font-size: 0.82rem;\n    line-height: 1.5;\n    color: rgba(195, 195, 205, 0.9);\n}\n\n.marketing-reconciliation__result-sub {\n    margin: 8px 0 0;\n    padding-top: 8px;\n    font-size: 0.76rem;\n    line-height: 1.5;\n    color: rgba(170, 170, 180, 0.86);\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n/*\n * --- Reconciliation: save / snapshots --------------------------------\n *\n * The save button shares the actions slot with \"Clear inputs\" and gets\n * the gold accent treatment so it reads as the primary CTA. The\n * snapshots list is a collapsible details-style block with a compact\n * table — wide enough to be useful, narrow enough not to dominate.\n */\n\n.marketing-reconciliation__actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: stretch;\n}\n\n@media (min-width: 901px) {\n    .marketing-reconciliation__actions {\n        flex-direction: row;\n        align-items: flex-end;\n        justify-content: flex-end;\n    }\n}\n\n.marketing-reconciliation__save {\n    padding: 9px 16px;\n    font-size: 0.84rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: rgba(20, 18, 12, 0.96);\n    background: linear-gradient(155deg, #d8b56a 0%, #b88d3c 100%);\n    border: 1px solid rgba(192, 159, 83, 0.7);\n    border-radius: 8px;\n    cursor: pointer;\n    transition:\n        transform 80ms ease,\n        box-shadow 120ms ease,\n        opacity 120ms ease;\n}\n\n.marketing-reconciliation__save:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 14px -8px rgba(210, 165, 80, 0.6);\n}\n\n.marketing-reconciliation__save:disabled {\n    cursor: not-allowed;\n    opacity: 0.45;\n}\n\n.marketing-reconciliation__snapshots {\n    margin-top: 20px;\n    padding: 18px 22px;\n    background: rgba(255,255,255,0.028);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n}\n\n.marketing-reconciliation__snapshots-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.marketing-reconciliation__snapshots-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 10px 7px 6px;\n    margin-left: -6px;\n    font-size: 0.86rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: rgba(235, 233, 228, 0.96);\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 120ms ease;\n}\n\n.marketing-reconciliation__snapshots-toggle:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.marketing-reconciliation__snapshots-count {\n    display: inline-flex;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 7px;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.74rem;\n    font-weight: 600;\n    color: rgba(255, 225, 170, 0.98);\n    background: rgba(210, 165, 80, 0.18);\n    border: 1px solid rgba(210, 165, 80, 0.45);\n    border-radius: 999px;\n}\n\n.marketing-reconciliation__snapshots-actions {\n    display: inline-flex;\n    gap: 8px;\n}\n\n.marketing-reconciliation__snapshots-export,\n.marketing-reconciliation__snapshots-clear {\n    padding: 7px 12px;\n    font-size: 0.78rem;\n    font-family: inherit;\n    color: rgba(225, 225, 230, 0.94);\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    border-radius: 7px;\n    cursor: pointer;\n    transition:\n        border-color 120ms ease,\n        color 120ms ease,\n        background 120ms ease;\n}\n\n.marketing-reconciliation__snapshots-export:hover {\n    border-color: rgba(210, 165, 80, 0.55);\n    color: rgba(255, 225, 170, 0.98);\n}\n\n.marketing-reconciliation__snapshots-clear:hover {\n    border-color: rgba(220, 110, 110, 0.55);\n    color: rgba(245, 175, 175, 0.98);\n}\n\n.marketing-reconciliation__snapshots-empty {\n    margin: 14px 0 0;\n    padding: 14px 14px;\n    font-size: 0.84rem;\n    line-height: 1.55;\n    color: rgba(180, 180, 190, 0.9);\n    border: 1px dashed rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.marketing-reconciliation__snapshots-empty strong {\n    color: rgba(245, 243, 238, 0.98);\n    font-weight: 600;\n}\n\n.marketing-reconciliation__snapshots-table-wrap {\n    margin-top: 14px;\n    overflow-x: auto;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 10px;\n}\n\n.marketing-reconciliation__snapshots-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n    color: rgba(225, 225, 230, 0.94);\n}\n\n.marketing-reconciliation__snapshots-table thead th {\n    padding: 9px 10px;\n    text-align: left;\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(180, 180, 190, 0.92);\n    background: rgba(255, 255, 255, 0.03);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: nowrap;\n}\n\n.marketing-reconciliation__snapshots-table tbody td {\n    padding: 9px 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    vertical-align: top;\n}\n\n.marketing-reconciliation__snapshots-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.marketing-reconciliation__snapshots-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.025);\n}\n\n.marketing-reconciliation__snapshots-table .num {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n.marketing-reconciliation__snapshots-metric,\n.marketing-reconciliation__snapshots-sub {\n    color: rgba(160, 160, 170, 0.86);\n    font-size: 0.74rem;\n}\n\n.marketing-reconciliation__snapshots-delete {\n    padding: 2px 8px;\n    font-size: 1rem;\n    line-height: 1;\n    font-family: inherit;\n    color: rgba(200, 200, 210, 0.7);\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    transition:\n        color 120ms ease,\n        border-color 120ms ease,\n        background 120ms ease;\n}\n\n.marketing-reconciliation__snapshots-delete:hover {\n    color: rgba(245, 175, 175, 0.98);\n    border-color: rgba(220, 110, 110, 0.45);\n    background: rgba(220, 110, 110, 0.08);\n}\n\n/*\n * --- Reconciliation: over-count & caption ----------------------------\n *\n * \"Over-count\" = the scope's attributed consents exceed the reported\n * clicks/sessions from the ad platform (multi-session visits, pre-\n * consented returns, UTM-tagged URLs shared beyond the ad). The row is\n * lightly tinted amber, the Reported cell carries a compact badge, and\n * the in-cell share label is capped at \"100%+\" so the math stays\n * readable.\n */\n.marketing-reconciliation__snapshots-caption {\n    margin: 0 0 10px;\n    font-size: 0.78rem;\n    line-height: 1.55;\n    color: rgba(180, 180, 190, 0.86);\n}\n\n.marketing-reconciliation__over-count-badge {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    padding: 1px 7px;\n    font-size: 0.66rem;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    text-transform: lowercase;\n    color: rgba(255, 225, 170, 0.98);\n    background: rgba(210, 165, 80, 0.18);\n    border: 1px solid rgba(210, 165, 80, 0.45);\n    border-radius: 999px;\n    vertical-align: middle;\n    white-space: nowrap;\n}\n\n.marketing-reconciliation__over-count-badge--inline {\n    margin: 0 4px;\n}\n\n.marketing-reconciliation__snapshots-row--overcount {\n    background: rgba(210, 165, 80, 0.05);\n    box-shadow: inset 3px 0 0 0 rgba(210, 165, 80, 0.45);\n}\n\n.marketing-reconciliation__snapshots-row--overcount:hover {\n    background: rgba(210, 165, 80, 0.09);\n}\n\n/*\n * --- Reconciliation: platform filter note ----------------------------\n *\n * The filter note sits between the inputs and the result cards. When\n * the filter is active and matched, it shows the coverage + matched\n * utm_source values. When active and empty, it swaps to a warn tone\n * prompting the user to fix their UTM tagging or switch to \"Other\".\n */\n\n.marketing-reconciliation__filter-note {\n    margin: 0 0 14px;\n    padding: 10px 14px;\n    font-size: 0.82rem;\n    line-height: 1.55;\n    color: rgba(215, 215, 220, 0.92);\n    background: rgba(0, 0, 0, 0.18);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 10px;\n}\n\n.marketing-reconciliation__filter-note p {\n    margin: 0;\n}\n\n.marketing-reconciliation__filter-note code {\n    padding: 1px 6px;\n    font-size: 0.78rem;\n    color: rgba(255, 225, 170, 0.95);\n    background: rgba(210, 165, 80, 0.1);\n    border: 1px solid rgba(210, 165, 80, 0.25);\n    border-radius: 5px;\n}\n\n.marketing-reconciliation__filter-note--empty {\n    color: rgba(245, 210, 170, 0.96);\n    background: linear-gradient(\n        155deg,\n        rgba(210, 130, 80, 0.15) 0%,\n        rgba(0, 0, 0, 0.22) 65%\n    );\n    border-color: rgba(220, 140, 90, 0.45);\n}\n\n/*\n * --- Reconciliation content tabs ----------------------------------------\n * Same pattern as .compliance-transfers__tab (Pages/Compliance/Style.css) —\n * no shared <Tabs> component exists in this app, so this mirrors that one\n * rather than inventing a new idiom.\n */\n\n.recon-tabs {\n    display: flex;\n    gap: 2px;\n    margin: 4px 0 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.recon-tab {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 14px 10px;\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 0.8rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    margin-bottom: -1px;\n    transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.recon-tab:hover {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.recon-tab.--active {\n    color: rgba(255, 255, 255, 0.88);\n    border-bottom-color: #c0a053;\n}\n\n/*\n * --- Reconciliation two-column layout -----------------------------------\n * Main content + a collapsible Suggestions rail. Sticky on wide screens so\n * suggestions stay visible while scrolling through tab content; stacks to\n * a single column on narrow screens.\n */\n\n.recon-layout {\n    display: grid;\n    grid-template-columns: 1fr 320px;\n    gap: 20px;\n    align-items: start;\n}\n\n.recon-layout__main {\n    min-width: 0;\n}\n\n.recon-layout__sidebar {\n    position: sticky;\n    top: 16px;\n}\n\n@media (max-width: 960px) {\n    .recon-layout {\n        grid-template-columns: 1fr;\n    }\n    .recon-layout__sidebar {\n        position: static;\n    }\n}\n\n.recon-sidecard__toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 10px 7px 6px;\n    margin: 0 0 8px -6px;\n    font-size: 0.86rem;\n    font-weight: 600;\n    font-family: inherit;\n    color: rgba(235, 233, 228, 0.96);\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 120ms ease;\n}\n\n.recon-sidecard__toggle:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.recon-sidecard__count {\n    display: inline-flex;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 7px;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.74rem;\n    font-weight: 600;\n    color: rgba(255, 225, 170, 0.98);\n    background: rgba(210, 165, 80, 0.18);\n    border: 1px solid rgba(210, 165, 80, 0.45);\n    border-radius: 999px;\n}\n\n/*\n * --- Suggestions strip ------------------------------------------------\n *\n * Sits between the KPI grid and the reconciliation panel. Visually quieter\n * than the KPI cards (no large numbers) so it reads as a *next move*\n * footnote, not as another metric. Severity is encoded in (1) a chip in\n * the card head, (2) a coloured left border, and (3) a faint background\n * tint — three independent cues so colour-blind readers still see the\n * priority distinction.\n */\n\n.marketing-suggestions {\n    margin: 0 0 28px;\n    padding: 16px 18px 18px;\n    border-radius: 14px;\n    background: linear-gradient(\n        155deg,\n        rgba(255, 255, 255, 0.03) 0%,\n        rgba(255, 255, 255, 0.01) 100%\n    );\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.marketing-suggestions__head {\n    margin: 0 0 12px;\n}\n\n.marketing-suggestions__title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgba(240, 232, 210, 0.95);\n}\n\n.marketing-suggestions__hint {\n    margin: 4px 0 0;\n    font-size: 0.78rem;\n    line-height: 1.45;\n    color: rgba(165, 165, 175, 0.9);\n    max-width: 56rem;\n}\n\n.marketing-suggestions__list {\n    display: grid;\n    gap: 10px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.marketing-suggestions__card {\n    position: relative;\n    padding: 14px 16px 14px 18px;\n    background: rgba(255, 255, 255, 0.025);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 10px;\n    border-left-width: 3px;\n}\n\n.marketing-suggestions__card--critical {\n    border-left-color: rgba(232, 95, 95, 0.85);\n    background: linear-gradient(\n        155deg,\n        rgba(232, 95, 95, 0.08) 0%,\n        rgba(255, 255, 255, 0.015) 70%\n    );\n}\n\n.marketing-suggestions__card--high {\n    border-left-color: rgba(210, 165, 80, 0.85);\n    background: linear-gradient(\n        155deg,\n        rgba(210, 165, 80, 0.07) 0%,\n        rgba(255, 255, 255, 0.015) 70%\n    );\n}\n\n.marketing-suggestions__card--medium {\n    border-left-color: rgba(130, 175, 220, 0.85);\n    background: linear-gradient(\n        155deg,\n        rgba(130, 175, 220, 0.05) 0%,\n        rgba(255, 255, 255, 0.015) 70%\n    );\n}\n\n.marketing-suggestions__card--low {\n    border-left-color: rgba(160, 160, 170, 0.6);\n}\n\n.marketing-suggestions__card-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 6px;\n}\n\n.marketing-suggestions__severity {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    font-size: 0.66rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    border-radius: 999px;\n    border: 1px solid currentColor;\n    line-height: 1.4;\n}\n\n.marketing-suggestions__severity--critical {\n    color: rgba(255, 180, 180, 0.95);\n    background: rgba(232, 95, 95, 0.12);\n}\n\n.marketing-suggestions__severity--high {\n    color: rgba(255, 225, 170, 0.95);\n    background: rgba(210, 165, 80, 0.14);\n}\n\n.marketing-suggestions__severity--medium {\n    color: rgba(190, 220, 245, 0.95);\n    background: rgba(130, 175, 220, 0.12);\n}\n\n.marketing-suggestions__severity--low {\n    color: rgba(200, 200, 210, 0.85);\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.marketing-suggestions__card-title {\n    margin: 0;\n    font-size: 0.92rem;\n    font-weight: 600;\n    color: rgba(240, 232, 210, 0.96);\n    line-height: 1.35;\n}\n\n.marketing-suggestions__card-body {\n    margin: 0 0 10px;\n    font-size: 0.84rem;\n    line-height: 1.5;\n    color: rgba(200, 200, 210, 0.92);\n}\n\n.marketing-suggestions__card-actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px 12px;\n}\n\n.marketing-suggestions__cta {\n    display: inline-flex;\n    align-items: center;\n    padding: 7px 14px;\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: rgba(20, 18, 12, 0.96);\n    background: linear-gradient(\n        155deg,\n        rgba(216, 181, 106, 0.96) 0%,\n        rgba(184, 141, 60, 0.96) 100%\n    );\n    border-radius: 7px;\n    text-decoration: none;\n    transition: filter 120ms ease, transform 120ms ease;\n}\n\n.marketing-suggestions__cta:hover,\n.marketing-suggestions__cta:focus-visible {\n    filter: brightness(1.07);\n    text-decoration: none;\n}\n\n.marketing-suggestions__cta:focus-visible {\n    outline: 2px solid rgba(255, 225, 170, 0.85);\n    outline-offset: 2px;\n}\n\n.marketing-suggestions__snooze {\n    padding: 6px 10px;\n    font-size: 0.76rem;\n    font-family: inherit;\n    color: rgba(200, 200, 210, 0.86);\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    border-radius: 7px;\n    cursor: pointer;\n    transition: border-color 120ms ease, color 120ms ease, background 120ms ease;\n}\n\n.marketing-suggestions__snooze:hover,\n.marketing-suggestions__snooze:focus-visible {\n    border-color: rgba(255, 255, 255, 0.32);\n    color: rgba(240, 240, 245, 0.96);\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.marketing-suggestions__snooze:focus-visible {\n    outline: 2px solid rgba(160, 160, 170, 0.6);\n    outline-offset: 2px;\n}\n\n.marketing-suggestions__evidence {\n    margin-top: 10px;\n    font-size: 0.76rem;\n    color: rgba(160, 160, 170, 0.9);\n}\n\n.marketing-suggestions__evidence summary {\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    color: rgba(180, 180, 190, 0.86);\n    transition: color 120ms ease;\n}\n\n.marketing-suggestions__evidence summary:hover {\n    color: rgba(220, 220, 230, 0.96);\n}\n\n.marketing-suggestions__evidence ul {\n    margin: 8px 0 0;\n    padding: 0 0 0 18px;\n    line-height: 1.55;\n}\n\n.marketing-suggestions__evidence code {\n    padding: 1px 6px;\n    font-size: 0.74rem;\n    color: rgba(220, 220, 230, 0.92);\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n}\n\n@media (min-width: 720px) {\n    .marketing-suggestions__card-head {\n        flex-wrap: nowrap;\n    }\n}\n\n/* ── Ad Reconciliation CTA (in Channel Analytics) ─────────────────────── */\n.marketing-reconciliation-cta {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 18px 24px;\n    margin: 32px 0;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 10px;\n}\n\n.marketing-reconciliation-cta__text {\n    margin: 0;\n    color: rgba(220, 220, 230, 0.75);\n    font-size: 0.9rem;\n}\n\n.marketing-reconciliation-cta__link {\n    white-space: nowrap;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: #7c9ff5;\n    text-decoration: none;\n}\n\n.marketing-reconciliation-cta__link:hover {\n    text-decoration: underline;\n}\n\n/* ── Reconcile page channel filter ────────────────────────────────────── */\n.marketing-reconciliation-page__channel-filter {\n    margin-bottom: 24px;\n}\n\n.marketing-reconciliation-page__channel-label {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 0.88rem;\n    color: rgba(220, 220, 230, 0.8);\n}\n\n.marketing-reconciliation-page__back-link {\n    color: #7c9ff5;\n    text-decoration: none;\n}\n\n.marketing-reconciliation-page__back-link:hover {\n    text-decoration: underline;\n}\n\n/* ── Shared section headers ────────────────────────────────────────────── */\n.marketing-reconciliation__section-title {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: rgba(220, 220, 230, 0.9);\n    margin: 0 0 4px;\n}\n\n.marketing-reconciliation__section-hint {\n    font-size: 0.82rem;\n    color: rgba(200, 200, 210, 0.55);\n    margin: 0 0 16px;\n    line-height: 1.5;\n}\n\n/* ── Platform comparison table ─────────────────────────────────────────── */\n.marketing-reconciliation__comparison {\n    margin: 28px 0 0;\n    padding: 20px 24px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 10px;\n}\n\n.marketing-reconciliation__comparison-wrap {\n    overflow-x: auto;\n}\n\n.marketing-reconciliation__comparison-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.86rem;\n}\n\n.marketing-reconciliation__comparison-table th,\n.marketing-reconciliation__comparison-table td {\n    padding: 8px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    white-space: nowrap;\n}\n\n.marketing-reconciliation__comparison-table th {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: rgba(200, 200, 210, 0.55);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.marketing-reconciliation__comparison-table td {\n    color: rgba(220, 220, 230, 0.85);\n}\n\n.marketing-reconciliation__comparison-table tr:last-child td {\n    border-bottom: none;\n}\n\n.marketing-reconciliation__comparison-table .num {\n    text-align: right;\n}\n\n.marketing-reconciliation__comparison-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 8px;\n    vertical-align: middle;\n    flex-shrink: 0;\n}\n\n.marketing-reconciliation__comparison-good {\n    color: #4caf7d;\n    font-weight: 600;\n}\n\n.marketing-reconciliation__comparison-warn {\n    color: #f5a623;\n    font-weight: 600;\n}\n\n/* ── Visibility improvement projection ─────────────────────────────────── */\n.marketing-reconciliation__projection {\n    margin: 20px 0 0;\n    padding: 22px 24px;\n    background: rgba(255, 255, 255, 0.028);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 14px;\n}\n\n.marketing-reconciliation__projection-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.86rem;\n}\n\n.marketing-reconciliation__projection-table th,\n.marketing-reconciliation__projection-table td {\n    padding: 8px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.marketing-reconciliation__projection-table th {\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: rgba(200, 200, 210, 0.55);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.marketing-reconciliation__projection-table td {\n    color: rgba(220, 220, 230, 0.85);\n}\n\n.marketing-reconciliation__projection-table tr:last-child td {\n    border-bottom: none;\n}\n\n.marketing-reconciliation__projection-table .num {\n    text-align: right;\n}\n\n.marketing-reconciliation__projection-row--current td {\n    color: rgba(200, 200, 210, 0.55);\n    font-style: italic;\n}\n\n/* ── Visibility trend chart ────────────────────────────────────────────── */\n.marketing-reconciliation__trend {\n    margin: 20px 0 0;\n    padding: 22px 24px;\n    background: rgba(255, 255, 255, 0.028);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 14px;\n}\n\n.marketing-reconciliation__trend-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n    margin-bottom: 12px;\n}\n\n.marketing-reconciliation__trend-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.82rem;\n    color: rgba(200, 200, 210, 0.8);\n}\n\n.marketing-reconciliation__trend-legend-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.marketing-reconciliation__trend-svg {\n    display: block;\n    width: 100%;\n    height: auto;\n    overflow: visible;\n}\n\n/* ── Domain gate ──────────────────────────────────────────────────────────── */\n\n.reconcile-domain-gate {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 56px 24px;\n    margin: 24px 0;\n    border-radius: 16px;\n    border: 1.5px dashed rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.04);\n    text-align: center;\n}\n\n.reconcile-domain-gate__icon {\n    font-size: 2rem;\n    opacity: 0.55;\n}\n\n.reconcile-domain-gate__heading {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: rgba(240, 235, 220, 0.9);\n}\n\n.reconcile-domain-gate__body {\n    margin: 0;\n    max-width: 36rem;\n    font-size: 0.875rem;\n    line-height: 1.6;\n    color: rgba(180, 175, 165, 0.85);\n}\n\n/* ── Ad Connection Manager ─────────────────────────────────────────────────── */\n\n.ad-connection-manager {\n    margin: 0 0 32px;\n    padding: 20px 22px 22px;\n    border-radius: 14px;\n    border: 1px solid rgba(100, 180, 255, 0.15);\n    background: rgba(30, 50, 80, 0.18);\n}\n\n.ad-connection-manager__header {\n    margin-bottom: 14px;\n}\n\n.ad-connection-manager__title {\n    margin: 0 0 6px;\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(130, 185, 255, 0.85);\n}\n\n.ad-connection-manager__hint {\n    margin: 0;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: rgba(160, 165, 175, 0.85);\n}\n\n.ad-connection-manager__loading {\n    font-size: 0.8rem;\n    color: rgba(160, 165, 175, 0.7);\n    margin: 0;\n}\n\n.ad-connection-manager__status {\n    margin: 0 0 12px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 0.8rem;\n    background: rgba(60, 200, 100, 0.12);\n    border: 1px solid rgba(60, 200, 100, 0.25);\n    color: rgba(160, 230, 160, 0.95);\n}\n\n.ad-connection-manager__status--error {\n    background: rgba(220, 80, 60, 0.1);\n    border-color: rgba(220, 80, 60, 0.25);\n    color: rgba(255, 160, 140, 0.95);\n}\n\n.ad-connection-manager__list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* ── Individual connection card ────────────────────────────────────────────── */\n\n.ad-connection-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.03);\n    transition: border-color 0.15s;\n}\n\n.ad-connection-card--connected {\n    border-color: rgba(60, 180, 255, 0.2);\n    background: rgba(30, 80, 140, 0.12);\n}\n\n.ad-connection-card__icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.92);\n}\n\n.ad-connection-card__info {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.ad-connection-card__name {\n    font-size: 0.84rem;\n    font-weight: 500;\n    color: rgba(220, 220, 228, 0.95);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ad-connection-card__meta {\n    font-size: 0.75rem;\n    color: rgba(120, 200, 120, 0.85);\n}\n\n.ad-connection-card__meta--dim {\n    color: rgba(140, 140, 150, 0.65);\n}\n\n.ad-connection-card__actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.ad-connection-card__btn {\n    padding: 5px 12px;\n    border-radius: 6px;\n    font-size: 0.77rem;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: background 0.15s, opacity 0.15s;\n}\n\n.ad-connection-card__btn:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.ad-connection-card__btn--connect {\n    background: rgba(60, 140, 255, 0.18);\n    border-color: rgba(60, 140, 255, 0.35);\n    color: rgba(130, 185, 255, 0.95);\n}\n\n.ad-connection-card__btn--connect:not(:disabled):hover {\n    background: rgba(60, 140, 255, 0.28);\n}\n\n.ad-connection-card__btn--import {\n    background: rgba(60, 200, 100, 0.14);\n    border-color: rgba(60, 200, 100, 0.3);\n    color: rgba(130, 220, 150, 0.95);\n}\n\n.ad-connection-card__btn--import:not(:disabled):hover {\n    background: rgba(60, 200, 100, 0.24);\n}\n\n.ad-connection-card__btn--disconnect {\n    background: transparent;\n    border-color: rgba(200, 100, 80, 0.25);\n    color: rgba(200, 140, 130, 0.75);\n}\n\n.ad-connection-card__btn--disconnect:hover {\n    background: rgba(200, 80, 60, 0.1);\n    color: rgba(220, 160, 145, 0.9);\n}\n\n/* ── Manual Customer ID input ──────────────────────────────── */\n.ad-manual-input-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.ad-manual-input {\n    background: #1a1d2e;\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 12px;\n    padding: 28px 32px;\n    width: 100%;\n    max-width: 420px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.ad-manual-input__title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgba(220, 225, 235, 0.95);\n    margin: 0;\n}\n\n.ad-manual-input__hint {\n    font-size: 0.82rem;\n    color: rgba(160, 165, 180, 0.8);\n    margin: 0;\n    line-height: 1.5;\n}\n\n.ad-manual-input__field {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 6px;\n    padding: 10px 14px;\n    color: rgba(220, 225, 235, 0.95);\n    font-size: 0.9rem;\n    width: 100%;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.ad-manual-input__field:focus {\n    border-color: rgba(100, 140, 255, 0.5);\n}\n\n.ad-manual-input__field::placeholder {\n    color: rgba(160, 165, 180, 0.45);\n}\n\n.ad-manual-input__actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n/* ── Inputs bar ────────────────────────────────────────────── */\n.recon-inputs-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 14px;\n    padding-bottom: 14px;\n    margin-bottom: 0;\n}\n.recon-inputs-bar__field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n.recon-inputs-bar__field--wide {\n    flex: 1;\n    min-width: 130px;\n}\n.recon-inputs-bar__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(160,165,175,0.85);\n}\n.recon-inputs-bar__actions {\n    display: flex;\n    gap: 8px;\n    align-items: flex-end;\n}\n\n/* ── Funnel + Gauge layout ─────────────────────────────────── */\n.recon-main {\n    display: flex;\n    gap: 20px;\n    align-items: flex-start;\n    margin: 0;\n    flex-wrap: wrap;\n}\n\n/* ── Funnel ────────────────────────────────────────────────── */\n.recon-funnel {\n    flex: 1;\n    min-width: 220px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0;\n    padding: 20px 16px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.025);\n}\n.recon-funnel__step {\n    width: 100%;\n    max-width: 200px;\n    text-align: center;\n    padding: 12px 16px;\n    border-radius: 10px;\n}\n.recon-funnel__step--reported {\n    background: rgba(120,160,220,0.1);\n    border: 1px solid rgba(120,160,220,0.2);\n}\n.recon-funnel__step--consents {\n    background: rgba(100,200,160,0.08);\n    border: 1px solid rgba(100,200,160,0.2);\n}\n.recon-funnel__step--visible {\n    background: rgba(80,200,120,0.12);\n    border: 1px solid rgba(80,200,120,0.25);\n}\n.recon-funnel__num {\n    font-size: 1.6rem;\n    font-weight: 700;\n    line-height: 1;\n    margin-bottom: 4px;\n    color: rgba(235,235,245,0.95);\n}\n.recon-funnel__label {\n    font-size: 0.75rem;\n    color: rgba(170,175,185,0.85);\n}\n.recon-funnel__arrow {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    padding: 6px 0;\n}\n.recon-funnel__arrow-pct {\n    font-size: 0.7rem;\n    color: rgba(150,155,165,0.8);\n}\n.recon-funnel__arrow-line {\n    font-size: 1.1rem;\n    color: rgba(150,155,165,0.5);\n}\n.recon-funnel__gap {\n    margin-top: 12px;\n    padding: 8px 14px;\n    border-radius: 8px;\n    background: rgba(220,80,60,0.08);\n    border: 1px solid rgba(220,80,60,0.2);\n    text-align: center;\n    width: 100%;\n    max-width: 200px;\n}\n.recon-funnel__gap-num {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: rgba(240,140,120,0.9);\n}\n.recon-funnel__gap-label {\n    font-size: 0.72rem;\n    color: rgba(200,130,110,0.8);\n}\n\n/* ── Gauge ─────────────────────────────────────────────────── */\n.recon-gauge {\n    min-width: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 20px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.025);\n}\n.recon-gauge__svg {\n    width: 180px;\n    height: 160px;\n    display: block;\n}\n.recon-gauge__cost {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n.recon-gauge__cost-label {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(150,155,165,0.7);\n}\n.recon-gauge__cost-val {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: rgba(235,235,245,0.95);\n}\n.recon-gauge__cost-sub {\n    font-size: 0.72rem;\n    color: rgba(150,155,165,0.7);\n}\n\n/* ── Connect hint ──────────────────────────────────────────── */\n.reconcile-connect-hint {\n    font-size: 0.78rem;\n    color: rgba(140,160,190,0.8);\n    margin-bottom: 16px;\n}\n.reconcile-connect-hint a {\n    color: rgba(100,170,255,0.9);\n    text-decoration: none;\n}\n.reconcile-connect-hint a:hover {\n    text-decoration: underline;\n}\n\n/* ── Ad Connections success banner ─────────────────────────────────────── */\n.ad-connections-success-banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px;\n    margin-bottom: 20px;\n    background: rgba(34, 197, 94, 0.12);\n    border: 1px solid rgba(34, 197, 94, 0.35);\n    border-radius: 8px;\n    color: rgba(134, 239, 172, 0.95);\n    font-size: 0.875rem;\n    font-weight: 500;\n}\n\n/* ── Account Picker Modal ───────────────────────────────────────────────── */\n.account-picker-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    background: rgba(8, 10, 18, 0.75);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n}\n\n.account-picker {\n    background: #13161f;\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n    width: 100%;\n    max-width: 480px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 24px 60px rgba(0,0,0,0.6);\n    outline: none;\n}\n\n.account-picker__header {\n    padding: 24px 24px 0;\n}\n\n.account-picker__title {\n    margin: 0 0 6px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: rgba(230,235,245,0.95);\n}\n\n.account-picker__sub {\n    margin: 0;\n    font-size: 0.85rem;\n    color: rgba(160,170,190,0.8);\n    line-height: 1.5;\n}\n\n.account-picker__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 24px;\n}\n\n.account-picker__loading,\n.account-picker__empty {\n    color: rgba(160,170,190,0.7);\n    font-size: 0.875rem;\n    margin: 8px 0;\n}\n\n.account-picker__error {\n    color: rgba(248,113,113,0.9);\n    font-size: 0.875rem;\n    margin: 8px 0;\n}\n\n.account-picker__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.account-picker__item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    border: 1px solid rgba(255,255,255,0.06);\n    background: rgba(255,255,255,0.03);\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s;\n}\n\n.account-picker__item:hover {\n    background: rgba(255,255,255,0.06);\n    border-color: rgba(255,255,255,0.12);\n}\n\n.account-picker__item--selected {\n    background: rgba(99,179,237,0.1);\n    border-color: rgba(99,179,237,0.45);\n}\n\n.account-picker__item--dim {\n    opacity: 0.55;\n}\n\n.account-picker__item-radio {\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 2px solid rgba(160,170,190,0.4);\n    background: transparent;\n    position: relative;\n    transition: border-color 0.15s;\n}\n\n.account-picker__item--selected .account-picker__item-radio {\n    border-color: #63b3ed;\n}\n\n.account-picker__item--selected .account-picker__item-radio::after {\n    content: \"\";\n    position: absolute;\n    inset: 3px;\n    border-radius: 50%;\n    background: #63b3ed;\n}\n\n.account-picker__item-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.account-picker__item-name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: rgba(220,230,245,0.95);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.account-picker__item-id {\n    font-size: 0.75rem;\n    color: rgba(140,155,180,0.75);\n    font-family: monospace;\n}\n\n.account-picker__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding: 16px 24px 20px;\n    border-top: 1px solid rgba(255,255,255,0.06);\n}\n\n.account-picker__btn {\n    padding: 9px 20px;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    transition: opacity 0.15s, background 0.15s;\n}\n\n.account-picker__btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n.account-picker__btn--cancel {\n    background: rgba(255,255,255,0.06);\n    color: rgba(180,185,200,0.9);\n}\n\n.account-picker__btn--cancel:not(:disabled):hover {\n    background: rgba(255,255,255,0.1);\n}\n\n.account-picker__btn--confirm {\n    background: #3b82f6;\n    color: #fff;\n}\n\n.account-picker__btn--confirm:not(:disabled):hover {\n    background: #2563eb;\n}\n\n/* ── Sync button & messages ────────────────────────────────────────────── */\n.recon-sync-btn {\n    padding: 7px 14px;\n    border-radius: 7px;\n    background: rgba(59, 130, 246, 0.15);\n    border: 1px solid rgba(59, 130, 246, 0.4);\n    color: rgba(147, 197, 253, 0.95);\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.15s, border-color 0.15s;\n    letter-spacing: 0.01em;\n}\n.recon-sync-btn:not(:disabled):hover {\n    background: rgba(59, 130, 246, 0.28);\n    border-color: rgba(59, 130, 246, 0.65);\n}\n.recon-sync-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n.recon-sync-msg {\n    font-size: 0.8rem;\n    color: rgba(134, 239, 172, 0.9);\n    margin: 6px 0 0;\n    padding: 7px 12px;\n    background: rgba(34,197,94,0.08);\n    border: 1px solid rgba(34,197,94,0.25);\n    border-radius: 6px;\n}\n.recon-sync-msg--error {\n    color: rgba(252,165,165,0.9);\n    background: rgba(239,68,68,0.08);\n    border-color: rgba(239,68,68,0.25);\n}\n.recon-sync-msg__link {\n    color: inherit;\n    opacity: 0.8;\n    text-decoration: underline;\n}\n.recon-sync-hint {\n    font-size: 0.78rem;\n    color: rgba(140,155,180,0.7);\n    margin: 5px 0 0;\n}\n.recon-sync-hint a {\n    color: rgba(100,170,255,0.85);\n    text-decoration: none;\n}\n.recon-sync-hint a:hover { text-decoration: underline; }\n\n/* ── UTM attribution health bar ────────────────────────────────────────── */\n.utm-health {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 14px;\n    margin: 8px 0;\n    border-radius: 8px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.06);\n    font-size: 0.8rem;\n    flex-wrap: wrap;\n}\n.utm-health__label {\n    color: rgba(160,170,190,0.8);\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.7rem;\n    letter-spacing: 0.05em;\n    white-space: nowrap;\n    min-width: 110px;\n}\n.utm-health__track {\n    flex: 1;\n    min-width: 80px;\n    height: 6px;\n    border-radius: 3px;\n    background: rgba(255,255,255,0.08);\n    overflow: hidden;\n}\n.utm-health__fill {\n    height: 100%;\n    border-radius: 3px;\n    transition: width 0.4s ease;\n}\n.utm-health--good .utm-health__fill { background: #4ade80; }\n.utm-health--warn .utm-health__fill { background: #f59e0b; }\n.utm-health--bad  .utm-health__fill { background: #f87171; }\n.utm-health__stats {\n    color: rgba(200,210,225,0.9);\n    white-space: nowrap;\n}\n.utm-health__stats strong { font-weight: 700; }\n.utm-health--good .utm-health__stats strong { color: #86efac; }\n.utm-health--warn .utm-health__stats strong { color: #fcd34d; }\n.utm-health--bad  .utm-health__stats strong { color: #fca5a5; }\n.utm-health__dark {\n    color: rgba(160,170,190,0.65);\n    font-size: 0.75rem;\n}\n\n/* ── Insights panel ─────────────────────────────────────────────────────── */\n.recon-insights {\n    margin: 0;\n    flex: 1;\n}\n.recon-insights__heading {\n    font-size: 0.78rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(160,170,190,0.7);\n    margin: 0 0 10px;\n}\n.recon-insights__list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n.recon-insight {\n    display: flex;\n    gap: 12px;\n    padding: 12px 16px;\n    border-radius: 10px;\n    border-left: 3px solid transparent;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.06);\n}\n.recon-insight--critical {\n    background: rgba(239,68,68,0.07);\n    border-color: rgba(239,68,68,0.25);\n    border-left-color: #ef4444;\n}\n.recon-insight--warning {\n    background: rgba(245,158,11,0.07);\n    border-color: rgba(245,158,11,0.25);\n    border-left-color: #f59e0b;\n}\n.recon-insight--opportunity {\n    background: rgba(59,130,246,0.07);\n    border-color: rgba(59,130,246,0.22);\n    border-left-color: #3b82f6;\n}\n.recon-insight--good {\n    background: rgba(34,197,94,0.06);\n    border-color: rgba(34,197,94,0.2);\n    border-left-color: #22c55e;\n}\n.recon-insight__icon {\n    font-size: 1rem;\n    flex-shrink: 0;\n    margin-top: 1px;\n    width: 18px;\n    text-align: center;\n}\n.recon-insight--critical .recon-insight__icon { color: #f87171; }\n.recon-insight--warning  .recon-insight__icon { color: #fbbf24; }\n.recon-insight--opportunity .recon-insight__icon { color: #60a5fa; }\n.recon-insight--good     .recon-insight__icon { color: #4ade80; }\n.recon-insight__content {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n}\n.recon-insight__title {\n    font-size: 0.875rem;\n    font-weight: 700;\n    color: rgba(220,230,245,0.95);\n    margin: 0;\n    line-height: 1.3;\n}\n.recon-insight__body {\n    font-size: 0.8rem;\n    color: rgba(170,180,200,0.85);\n    margin: 0;\n    line-height: 1.55;\n}\n\n/* ── Chart sections ─────────────────────────────────────────────────────── */\n.recon-chart-section {\n    margin: 0;\n    background: rgba(255,255,255,0.028);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n    padding: 20px 20px 16px;\n}\n\n.recon-chart-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.recon-bar-chart {\n    display: block;\n    width: 100%;\n    max-width: 620px;\n    height: auto;\n    overflow: visible;\n}\n\n.recon-chart-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 14px;\n    margin-top: 10px;\n    font-size: 0.78rem;\n    color: rgba(160,175,200,0.75);\n    align-items: center;\n}\n\n.recon-legend-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 4px;\n    vertical-align: middle;\n    flex-shrink: 0;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   DASHBOARD LAYOUT — page header, KPI row, card grid\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n.recon-page {\n    padding-bottom: 48px;\n}\n\n/* ── Page header ──────────────────────────────────────────────────────────── */\n.recon-page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 24px;\n    padding-bottom: 18px;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n}\n.recon-page-header__left {\n    display: flex;\n    align-items: baseline;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n.recon-page-header__title {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: rgba(240,242,248,0.97);\n    letter-spacing: -0.01em;\n}\n.recon-page-header__domain {\n    font-size: 0.82rem;\n    color: rgba(155,170,200,0.75);\n    padding: 3px 10px;\n    border-radius: 20px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.1);\n}\n.recon-page-header__right {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n.recon-page-header__channel {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.8rem;\n    color: rgba(160,165,175,0.8);\n}\n\n.recon-page-header__channel .marketing-reconciliation__select {\n    width: auto;\n    min-width: 140px;\n}\n.recon-page-header__back {\n    font-size: 0.82rem;\n    color: rgba(130,145,175,0.75);\n    text-decoration: none;\n    transition: color 0.15s;\n}\n.recon-page-header__back:hover {\n    color: rgba(180,190,215,0.9);\n}\n\n/* ── Generic card ─────────────────────────────────────────────────────────── */\n.recon-card {\n    background: rgba(255,255,255,0.028);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n    padding: 22px 22px 20px;\n}\n.recon-controls-card {\n    margin-bottom: 20px;\n}\n.recon-card--insights {\n    display: flex;\n    flex-direction: column;\n}\n.recon-card__title {\n    margin: 0 0 14px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(145,158,185,0.65);\n}\n.recon-card__empty-hint {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 24px 16px;\n    font-size: 0.85rem;\n    color: rgba(140,152,175,0.6);\n    text-align: center;\n}\n\n/* ── KPI stat cards ───────────────────────────────────────────────────────── */\n.recon-kpi-row {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 14px;\n    margin-bottom: 20px;\n}\n@media (max-width: 900px) {\n    .recon-kpi-row { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 480px) {\n    .recon-kpi-row { grid-template-columns: 1fr 1fr; }\n}\n\n.recon-stat-card {\n    background: rgba(255,255,255,0.032);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 12px;\n    padding: 16px 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n.recon-stat-card--good {\n    border-color: rgba(74,222,128,0.2);\n    background: rgba(74,222,128,0.045);\n}\n.recon-stat-card--warn {\n    border-color: rgba(245,158,11,0.2);\n    background: rgba(245,158,11,0.045);\n}\n.recon-stat-card--bad {\n    border-color: rgba(248,113,113,0.2);\n    background: rgba(248,113,113,0.045);\n}\n.recon-stat-card--ga4 {\n    border-color: rgba(227,116,0,0.25);\n    background: rgba(227,116,0,0.055);\n}\n.recon-stat-card--ga4 .recon-stat-card__value { color: rgba(251,191,36,0.95); }\n.recon-stat-card__label {\n    font-size: 0.68rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(145,158,180,0.72);\n}\n.recon-stat-card__value {\n    font-size: 1.8rem;\n    font-weight: 700;\n    line-height: 1.05;\n    color: rgba(232,236,248,0.96);\n    letter-spacing: -0.025em;\n}\n.recon-stat-card--good .recon-stat-card__value { color: rgba(134,239,172,0.95); }\n.recon-stat-card--warn .recon-stat-card__value { color: rgba(252,211,77,0.92); }\n.recon-stat-card--bad  .recon-stat-card__value { color: rgba(248,113,113,0.9); }\n.recon-stat-card__sub {\n    font-size: 0.71rem;\n    color: rgba(135,148,170,0.6);\n    margin-top: 1px;\n}\n\n/* ── Dashboard 2-col grid (funnel + insights) ─────────────────────────────── */\n.recon-dashboard-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 20px;\n    align-items: start;\n}\n@media (max-width: 820px) {\n    .recon-dashboard-grid { grid-template-columns: 1fr; }\n}\n\n/* ── Charts 2-col grid ────────────────────────────────────────────────────── */\n.recon-charts-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n.recon-charts-grid > .recon-chart-section:only-child {\n    grid-column: 1 / -1;\n}\n@media (max-width: 820px) {\n    .recon-charts-grid { grid-template-columns: 1fr; }\n}\n\n/* ── Alert settings button ───────────────────────────────────────────────── */\n.recon-alerts-settings-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px 12px;\n    background: rgba(99,102,241,0.12);\n    border: 1px solid rgba(99,102,241,0.28);\n    border-radius: 8px;\n    color: rgba(165,168,255,0.9);\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n.recon-alerts-settings-btn:hover {\n    background: rgba(99,102,241,0.22);\n    border-color: rgba(99,102,241,0.5);\n}\n\n/* ── Notification bell ───────────────────────────────────────────────────── */\n.notif-bell {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n.notif-bell__btn {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.09);\n    border-radius: 8px;\n    color: rgba(180,190,210,0.75);\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.notif-bell__btn:hover {\n    background: rgba(255,255,255,0.09);\n    color: rgba(220,225,240,0.95);\n    border-color: rgba(255,255,255,0.15);\n}\n.notif-bell__btn--active {\n    color: rgba(252,211,77,0.9);\n    border-color: rgba(252,211,77,0.3);\n    background: rgba(252,211,77,0.07);\n}\n.notif-bell__badge {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    min-width: 16px;\n    height: 16px;\n    padding: 0 3px;\n    background: #ef4444;\n    border-radius: 9px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    color: #fff;\n    line-height: 16px;\n    text-align: center;\n    pointer-events: none;\n}\n\n/* ── Notification dropdown ───────────────────────────────────────────────── */\n.notif-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    width: 320px;\n    max-height: 420px;\n    background: rgba(18,22,36,0.97);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 14px;\n    box-shadow: 0 12px 40px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    z-index: 999;\n    overflow: hidden;\n}\n.notif-dropdown__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px 10px;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n    flex-shrink: 0;\n}\n.notif-dropdown__title {\n    font-size: 0.78rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: rgba(180,190,215,0.7);\n}\n.notif-dropdown__mark-all {\n    font-size: 0.71rem;\n    color: rgba(99,102,241,0.9);\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    text-decoration: underline;\n}\n.notif-dropdown__list {\n    overflow-y: auto;\n    flex: 1;\n    padding: 6px 0;\n}\n.notif-dropdown__empty {\n    margin: 0;\n    padding: 16px;\n    font-size: 0.78rem;\n    color: rgba(155,165,185,0.65);\n    line-height: 1.5;\n}\n\n/* ── Notification item ───────────────────────────────────────────────────── */\n.notif-item {\n    position: relative;\n    padding: 10px 16px 10px 14px;\n    border-left: 3px solid transparent;\n    cursor: pointer;\n    transition: background 0.12s;\n}\n.notif-item:hover { background: rgba(255,255,255,0.04); }\n.notif-item--unread { background: rgba(99,102,241,0.05); }\n.notif-item__meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 3px;\n    gap: 8px;\n}\n.notif-item__type {\n    font-size: 0.67rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n.notif-item__time {\n    font-size: 0.67rem;\n    color: rgba(130,140,165,0.6);\n    flex-shrink: 0;\n}\n.notif-item__title {\n    margin: 0;\n    font-size: 0.8rem;\n    color: rgba(215,220,235,0.88);\n    line-height: 1.4;\n}\n.notif-item__dot {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #6366f1;\n}\n\n/* ── Alert settings modal ────────────────────────────────────────────────── */\n.alert-settings-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(5,8,20,0.72);\n    backdrop-filter: blur(4px);\n    z-index: 1200;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: 48px 16px;\n    overflow-y: auto;\n}\n.alert-settings-modal {\n    background: rgb(14,18,30);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 18px;\n    box-shadow: 0 24px 72px rgba(0,0,0,0.7);\n    width: 100%;\n    max-width: 560px;\n    padding: 28px 28px 32px;\n    position: relative;\n}\n.alert-settings-modal__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 22px;\n}\n.alert-settings-modal__title {\n    margin: 0 0 5px;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: rgba(232,236,248,0.95);\n}\n.alert-settings-modal__sub {\n    margin: 0;\n    font-size: 0.8rem;\n    color: rgba(150,160,185,0.75);\n    line-height: 1.5;\n}\n.alert-settings-modal__close {\n    flex-shrink: 0;\n    width: 30px;\n    height: 30px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.09);\n    border-radius: 8px;\n    color: rgba(180,190,215,0.7);\n    font-size: 1.1rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.12s;\n}\n.alert-settings-modal__close:hover { background: rgba(255,255,255,0.1); }\n\n/* channels section */\n.alert-settings-channels {\n    background: rgba(255,255,255,0.025);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 12px;\n    padding: 16px 18px;\n    margin-bottom: 24px;\n}\n.alert-settings-channels__title {\n    margin: 0 0 12px;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: rgba(140,150,175,0.7);\n}\n.alert-settings-channels__row {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n.alert-settings-channels__item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n.alert-settings-channels__icon {\n    font-size: 1rem;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n.alert-settings-channels__info {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex: 1;\n}\n.alert-settings-channels__name {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: rgba(210,218,235,0.88);\n}\n.alert-settings-channels__status {\n    font-size: 0.74rem;\n    color: rgba(130,140,165,0.65);\n}\n.alert-settings-email-input {\n    width: 100%;\n    padding: 7px 10px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 8px;\n    color: rgba(210,218,235,0.9);\n    font-size: 0.82rem;\n    outline: none;\n    transition: border-color 0.15s;\n}\n.alert-settings-email-input:focus { border-color: rgba(99,102,241,0.5); }\n.alert-settings-push-btn {\n    padding: 6px 12px;\n    background: rgba(99,102,241,0.12);\n    border: 1px solid rgba(99,102,241,0.3);\n    border-radius: 8px;\n    color: rgba(165,168,255,0.9);\n    font-size: 0.77rem;\n    font-weight: 600;\n    cursor: pointer;\n    width: fit-content;\n    transition: background 0.15s;\n}\n.alert-settings-push-btn:hover { background: rgba(99,102,241,0.22); }\n.alert-settings-push-btn--active {\n    background: rgba(74,222,128,0.1);\n    border-color: rgba(74,222,128,0.3);\n    color: rgba(134,239,172,0.9);\n}\n\n/* alert rules */\n.alert-settings-rules__title {\n    margin: 0 0 12px;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: rgba(140,150,175,0.7);\n}\n.alert-settings-rules {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.alert-rule {\n    background: rgba(255,255,255,0.025);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 11px;\n    padding: 14px 16px;\n    transition: border-color 0.15s, background 0.15s;\n}\n.alert-rule--enabled {\n    border-color: rgba(99,102,241,0.25);\n    background: rgba(99,102,241,0.04);\n}\n.alert-rule__top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n}\n.alert-rule__toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n.alert-rule__toggle input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    accent-color: #6366f1;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n.alert-rule__toggle-label {\n    font-size: 0.84rem;\n    font-weight: 600;\n    color: rgba(210,218,235,0.9);\n}\n.alert-rule__threshold {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n}\n.alert-rule__threshold-input {\n    width: 72px;\n    padding: 5px 8px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 7px;\n    color: rgba(210,218,235,0.9);\n    font-size: 0.82rem;\n    text-align: right;\n    outline: none;\n    transition: border-color 0.15s;\n}\n.alert-rule__threshold-input:focus { border-color: rgba(99,102,241,0.5); }\n.alert-rule__threshold-input:disabled { opacity: 0.4; }\n.alert-rule__unit {\n    font-size: 0.76rem;\n    color: rgba(140,150,175,0.65);\n    min-width: 24px;\n}\n.alert-rule__hint {\n    margin: 6px 0 0;\n    font-size: 0.74rem;\n    color: rgba(130,140,165,0.65);\n    line-height: 1.45;\n}\n.alert-rule__channels {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid rgba(255,255,255,0.06);\n}\n.alert-rule__channel-toggle {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 0.77rem;\n    color: rgba(175,185,210,0.8);\n    cursor: pointer;\n}\n.alert-rule__channel-toggle input[type=\"checkbox\"] {\n    width: 13px;\n    height: 13px;\n    accent-color: #6366f1;\n    flex-shrink: 0;\n}\n.alert-rule__channel-note {\n    font-size: 0.7rem;\n    color: rgba(120,130,155,0.6);\n    font-style: italic;\n}\n\n/* ── Cost by channel table ───────────────────────────────────────────────── */\n.cost-by-channel {\n    width: 100%;\n}\n.cost-by-channel__table-wrap {\n    overflow-x: auto;\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.07);\n}\n.cost-by-channel__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n.cost-by-channel__table th {\n    padding: 9px 14px;\n    background: rgba(255,255,255,0.03);\n    color: rgba(140,152,178,0.72);\n    font-size: 0.68rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    text-align: left;\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n    white-space: nowrap;\n}\n.cost-by-channel__table th.num,\n.cost-by-channel__table td.num {\n    text-align: right;\n}\n.cost-by-channel__table td {\n    padding: 10px 14px;\n    color: rgba(210,218,235,0.88);\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    vertical-align: middle;\n    white-space: nowrap;\n}\n.cost-by-channel__table tbody tr:last-child td {\n    border-bottom: none;\n}\n.cost-by-channel__table tbody tr:hover td {\n    background: rgba(255,255,255,0.02);\n}\n.cost-by-channel__dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 7px;\n    vertical-align: middle;\n    flex-shrink: 0;\n}\n.cost-col {\n    background: rgba(99,102,241,0.04);\n}\n.cost-by-channel__good { color: rgba(134,239,172,0.9) !important; }\n.cost-by-channel__warn { color: rgba(252,211,77,0.85) !important; }\n.cost-by-channel__bad  { color: rgba(248,113,113,0.85) !important; }\n.cost-by-channel__avg-row td {\n    border-top: 1px solid rgba(255,255,255,0.07);\n    background: rgba(255,255,255,0.025);\n    color: rgba(175,185,210,0.75);\n    font-size: 0.78rem;\n}\n\n/* ── Connect prompt (inline, below inputs bar) ───────────────────────────── */\n.recon-connect-prompt {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    padding: 10px 0 4px;\n}\n.recon-connect-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 16px;\n    background: linear-gradient(135deg, rgba(99,102,241,0.18) 0%, rgba(139,92,246,0.18) 100%);\n    border: 1px solid rgba(99,102,241,0.4);\n    border-radius: 9px;\n    color: rgba(165,168,255,0.95);\n    font-size: 0.82rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s, opacity 0.15s;\n    white-space: nowrap;\n}\n.recon-connect-btn::before {\n    content: \"→\";\n    font-size: 0.9rem;\n}\n.recon-connect-btn:hover {\n    background: linear-gradient(135deg, rgba(99,102,241,0.28) 0%, rgba(139,92,246,0.28) 100%);\n    border-color: rgba(99,102,241,0.65);\n}\n.recon-connect-btn:disabled { opacity: 0.55; cursor: wait; }\n.recon-connect-prompt__hint {\n    font-size: 0.75rem;\n    color: rgba(130,140,165,0.65);\n}\n\n/* ── OAuth result banner ─────────────────────────────────────────────────── */\n.oauth-banner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 18px;\n    border-radius: 11px;\n    margin-bottom: 16px;\n    font-size: 0.83rem;\n    font-weight: 500;\n}\n.oauth-banner--success {\n    background: rgba(74,222,128,0.1);\n    border: 1px solid rgba(74,222,128,0.28);\n    color: rgba(134,239,172,0.95);\n}\n.oauth-banner--error {\n    background: rgba(248,113,113,0.09);\n    border: 1px solid rgba(248,113,113,0.3);\n    color: rgba(252,165,165,0.95);\n}\n.oauth-banner__msg { flex: 1; }\n.oauth-banner__close {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1.1rem;\n    color: inherit;\n    opacity: 0.7;\n    padding: 0 4px;\n    line-height: 1;\n}\n.oauth-banner__close:hover { opacity: 1; }\n\n/* ── Account picker modal ────────────────────────────────────────────────── */\n.acct-picker-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(5,8,20,0.78);\n    backdrop-filter: blur(5px);\n    z-index: 1300;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n}\n.acct-picker-modal {\n    background: rgb(14,18,30);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 18px;\n    box-shadow: 0 28px 80px rgba(0,0,0,0.75);\n    width: 100%;\n    max-width: 480px;\n    padding: 28px 28px 24px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n}\n.acct-picker-modal__header { margin-bottom: 18px; }\n.acct-picker-modal__title {\n    margin: 0 0 5px;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: rgba(232,236,248,0.95);\n}\n.acct-picker-modal__sub {\n    margin: 0;\n    font-size: 0.8rem;\n    color: rgba(150,160,185,0.75);\n}\n.acct-picker-modal__loading,\n.acct-picker-modal__empty {\n    margin: 0 0 16px;\n    font-size: 0.82rem;\n    color: rgba(150,160,185,0.7);\n}\n.acct-picker-modal__error {\n    margin: 0 0 16px;\n    font-size: 0.82rem;\n    color: rgba(252,165,165,0.9);\n    background: rgba(248,113,113,0.08);\n    border: 1px solid rgba(248,113,113,0.2);\n    border-radius: 8px;\n    padding: 10px 14px;\n}\n.acct-picker-list {\n    list-style: none;\n    margin: 0 0 16px;\n    padding: 0;\n    overflow-y: auto;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n.acct-picker-item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 13px 16px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 11px;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.13s, border-color 0.13s;\n}\n.acct-picker-item:hover:not(:disabled) {\n    background: rgba(99,102,241,0.1);\n    border-color: rgba(99,102,241,0.35);\n}\n.acct-picker-item:disabled { opacity: 0.5; cursor: wait; }\n.acct-picker-item__name {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(218,224,240,0.95);\n    flex: 1;\n}\n.acct-picker-item__meta {\n    font-size: 0.72rem;\n    color: rgba(130,140,165,0.65);\n    white-space: nowrap;\n}\n.acct-picker-item__arrow {\n    flex-shrink: 0;\n    color: rgba(99,102,241,0.6);\n}\n.acct-picker-modal__cancel {\n    width: 100%;\n    padding: 10px;\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 9px;\n    color: rgba(155,165,190,0.7);\n    font-size: 0.82rem;\n    cursor: pointer;\n    transition: background 0.13s;\n    flex-shrink: 0;\n}\n.acct-picker-modal__cancel:hover { background: rgba(255,255,255,0.08); }\n\n\n/* ── Ad Performance panel (Channel Analytics) ──────────────────────────────── */\n.ca-ad-perf {\n    margin: 0 0 18px;\n}\n.ca-ad-perf__title {\n    font-size: 0.78rem;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(155,165,190,0.55);\n    margin: 0 0 10px;\n}\n.ca-ad-perf__cards {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n.ca-ad-perf-card {\n    flex: 1 1 220px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 10px;\n    padding: 12px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n.ca-ad-perf-card__platform {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: rgba(200,210,230,0.85);\n}\n.ca-ad-perf-card__metrics {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n}\n.ca-ad-perf-card__metric {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n.ca-ad-perf-card__val {\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: rgba(220,225,240,0.9);\n    font-variant-numeric: tabular-nums;\n}\n.ca-ad-perf-card__lbl {\n    font-size: 0.7rem;\n    color: rgba(130,140,165,0.6);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n.ca-ad-perf-card__metric--accent .ca-ad-perf-card__val {\n    color: rgba(192,159,83,0.95);\n}\n.ca-ad-perf-card__metric--accent .ca-ad-perf-card__lbl {\n    color: rgba(192,159,83,0.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
